<div class="modal-body col-md-12 col-xs-12 p0 m0" id="quick_purchase_body"
  [ngClass]="{'event-payment': eventPaymentMode, 'main': !eventPaymentMode}">
  <!-- <div *ngIf="eventPaymentMode" class="title" [routerLink]="['/dashboard']">
      <h1><span i18n="page title | dashboard checkout">קופה</span> ({{event_details?.event_id}}) {{event_details?.title}}</h1>
    </div> -->
  <div class="promotion-main">
    <div class="event-back-arrow">
      <div class="close-dialog-arrow" (click)="closePurchase()">
        <svg class="arrow-close-modal" width="10" height="14" viewBox="0 0 10 14" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M9.49219 1.64063L4.13281 7L9.49219 12.3594L7.85156 14L0.851562 7L7.85156 0L9.49219 1.64063Z"
            fill="white" />
        </svg>
      </div>
    </div>
    <div class="promotion-title"><span i18n="@@Checkout">Checkout</span>&nbsp;{{event_details?.title}}&nbsp;
    </div>
    <div class="promotion-event">&nbsp;{{event_id}}&nbsp;</div>
  </div>
  <div *ngIf="step === 'facebook_connect'">
    <div *ngIf="!full_purchase && !eventPaymentMode" class="close_modal">
      <div class="col-md-12 col-xs-12">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div class="fb_friends col-md-12 col-xs-12 text-center"
      style="padding: 10px 0 30px; border-bottom: 2px solid #747B85;">
      <div class="fb_icons">
        <div class="round">
          <img class="blur" src="/assets/images/userImage1.jpg">
        </div>
        <div class="round">
          <img class="blur" src="/assets/images/userImage2.jpg">
        </div>
        <div class="round">
          <img class="blur" src="/assets/images/userImage3.jpg">
        </div>
        <div class="round">
          <img class="blur" src="/assets/images/userImage4.jpg">
        </div>
      </div>
    </div>
    <div class="col-md-12 col-xs-12 mt20 mb20">
      <p class="desc text-center"
        style="font-size: 1.3em;">To proceed with your purchase, you need to log in with Facebook</p>
    </div>
    <div class="col-md-12 col-xs-12 text-center">
      <button (click)="FBlogin()" class="btn btn-primary"
        style="background-color: #0095A5; font-size: 1.3em;">Log in with Facebook</button>
    </div>
  </div>
  <div class="category_step" [hidden]="step != 'category_step'">
    <div *ngIf="!full_purchase && !eventPaymentMode" class="close_modal">
      <div class="col-md-12 col-xs-12">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <!-- facebook section -->
    <div *ngIf="fb_module && facebook_id != '0'" class="facebook_section">
      <div class="col-md-12 col-xs-12 text-center">
        <img class="img-responsive center_image rouded_image"
          [src]="images_base_url + '/facebook/' + facebook_id + '_profile.jpg'">
        <p class="text-center"
          style="color: #747B85; font-size: 1em;">Not you? Switch account</p>
      </div>
    </div>
    <div *ngIf="fb_module && facebook_id == '0'" class="facebook_section ">
      <div class="fb_friends col-md-12 col-xs-12 text-center">
        <div class="fb_icons">
          <div class="round">
            <img class="blur" src="/assets/images/userImage1.jpg">
          </div>
          <div class="round">
            <img class="blur" src="/assets/images/userImage2.jpg">
          </div>
          <div class="round">
            <img class="blur" src="/assets/images/userImage3.jpg">
          </div>
          <div class="round">
            <img class="blur" src="/assets/images/userImage4.jpg">
          </div>
        </div>
      </div>
      <div class="col-md-12 col-xs-12 mt20 mb20">
        <p class="desc text-center"
          style="font-size: 1.3em;">Want to see which of your friends are going to this event?</p>
      </div>
      <div class="col-md-12 col-xs-12 text-center mb10">
        <button  (click)="FBlogin()" class="btn btn-primary"
          style="background-color: #0095A5; font-size: 1.3em;">Log in with Facebook</button>
      </div>
    </div>
    <!-- tickets category: -->
    <div *ngIf="tickets?.length > 0" class="tickets_category" (click)="showItems(1)">
      <div class="col-md-12 col-xs-12 vertical-align item_block">
        <!-- ticket icon: -->
        <div class="col-md-2 col-xs-2 ticket_icon pull-right">
          <img class="img-responsive" width="30" src="/assets/images/landingPage/ticket.png">
        </div>
        <!-- ticket name and price -->
        <div class="col-md-8 col-xs-8 pull-right">
          <h4 class="category-title" i18n="@@PurchaseModalOrderaTicket">Order a ticket</h4>
        </div>
        <!-- choose ticket: -->
        <div class="col-md-2 col-xs-2 ticket_selection text-center">
          <i class="fa {{faAngleLeftRtlRightLtr}} icon-item-size"></i>
        </div>
      </div>
    </div>
    <!-- rooms category: -->
    <div *ngIf="rooms?.length > 0" class="rooms_category" (click)="showItems(2)">
      <div class="col-md-12 col-xs-12 vertical-align item_block">
        <!-- ticket icon: -->
        <div class="col-md-2 col-xs-2 ticket_icon pull-right">
          <img class="img-responsive" width="30" src="/assets/images/landingPage/key.png">
        </div>
        <!-- ticket name and price -->
        <div class="col-md-8 col-xs-8 pull-right">
          <h4 class="category-title">Book a room</h4>
        </div>
        <!-- choose ticket: -->
        <div class="col-md-2 col-xs-2 room_selection text-center">
          <i class="fa {{faAngleLeftRtlRightLtr}} icon-item-size"></i>
        </div>
      </div>
    </div>
    <!-- tables category: -->
    <div *ngIf="tables?.length > 0" class="tables_category" (click)="showItems(3)">
      <div class="col-md-12 col-xs-12 vertical-align item_block">
        <!-- ticket icon: -->
        <div class="col-md-2 col-xs-2 ticket_icon pull-right">
          <img class="img-responsive" width="30" src="/assets/images/landingPage/table.png">
        </div>
        <!-- ticket name and price -->
        <div class="col-md-8 col-xs-8 pull-right">
          <h4 class="category-title" i18n="category title | order table">Book a table</h4>
        </div>
        <!-- choose ticket: -->
        <div class="col-md-2 col-xs-2 table_selection text-center">
          <i class="fa {{faAngleLeftRtlRightLtr}} icon-item-size"></i>
        </div>
      </div>
    </div>
    <div *ngIf="false">
      <h4 i18n="@@PurchaseModalnoavailableitems">No tickets found for this event.</h4>
    </div>
  </div>
<!--  SEATS IO-->
  <div class="seats_step" >
    <div style="min-height: 290px;" [ngStyle]="{'display': showSeatsDisplay ? 'block' : 'none' }" [ngClass]="{'iOS' : globals.isIos()}" class="seating-chart" *ngIf="showSeatsIo" >
      <si-seatsio-seating-chart [config]="seatsConfig"></si-seatsio-seating-chart>
    </div>

    <div class="boxMargin seats-fixed {{dir}}" [@fade] *ngIf="showSeatsDisplay">
      <ng-container *ngTemplateOutlet="templateSeats"></ng-container>
    </div>
  </div>
  <!--  SEATS IO END-->
  <div class="tickets_step" *ngIf="step === 'items_section'" [@fade]>
    <div *ngIf="!full_purchase && !eventPaymentMode" class="close_modal">
      <div class="col-md-12 col-xs-12">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div *ngIf="!noCategory" class="row mt15 pr25">
      <div (click)="returnTo('category_step')" class="col-md-2 col-xs-2">
        <i class="fa {{faAngleRightRtlLeftLtr}} disabled icon-nav-size"></i>
      </div>
      <div class="col-md-10 col-xs-10">
        <p id="item_category" class="disabled">
          Order {
          title, select,
          ticket {ticket}
          room {room}
          table {table}
          register {register}
          other {other}
          }
        </p>
      </div>
    </div>
    <!-- facebook section -->
    <div *ngIf="fb_module && noCategory && facebook_id != '0'" class="facebook_section">
      <div class="col-md-12 col-xs-12 text-center">
        <img class="img-responsive center_image rouded_image"
          [src]="images_base_url + '/facebook/' + facebook_id + '_profile.jpg'">
        <p class="text-center"
          style="color: #747B85; font-size: 1em;">Not you? Switch account</p>
      </div>
    </div>
    <div *ngIf="fb_module && noCategory && facebook_id == '0'" class="facebook_section ">
      <div class="fb_friends col-md-12 col-xs-12 text-center">
        <div class="fb_icons">
          <div class="round">
            <img class="blur" src="/assets/images/userImage1.jpg">
          </div>
          <div class="round">
            <img class="blur" src="/assets/images/userImage2.jpg">
          </div>
          <div class="round">
            <img class="blur" src="/assets/images/userImage3.jpg">
          </div>
          <div class="round">
            <img class="blur" src="/assets/images/userImage4.jpg">
          </div>
        </div>
      </div>
      <div class="col-md-12 col-xs-12 mt20 mb20">
        <p class="desc text-center"
          style="font-size: 1.3em;">Want to see which of your friends are going to this event?</p>
      </div>
      <div class="col-md-12 col-xs-12 text-center mb10">
        <button (click)="FBlogin()" class="btn btn-primary"
          style="background-color: #0095A5; font-size: 1.3em;">Log in with Facebook</button>
      </div>
    </div>
    <!-- tickets category: -->
    <div *ngIf="purchase_item === 1 && !showSeatsIo" class="ticket_items">
      <div *ngIf="categories && categories.length">
        <div *ngFor="let category of categories; let i=index">
          <div class="category-view" *ngIf="category.show">
            <div class="category-header cat-header-align"
                 (click)="showCategory[i] = !showCategory[i]">
              <p *ngIf="category.name" class="text-center category-name">{{category.name}}</p>
              <p *ngIf="category.comment" class="text-center category-description"><span>{{category.comment}}</span></p>
            </div>
            <div class="tickets" [attr.item_id]="ticket.id" [hidden]="!showCategory[i]"
                 [ngClass]="{'disabled_bg': ticket.availability == 2 || ticket.availability == 3 || ticket.availability == 4 }"
                 *ngFor="let ticket of ticketsFiltered[category.id]; let j = index;">
<!--              <div [ngClass]="{'sold-out': (ticket?.limits.length < 1 || ticket.availability == 4)}"></div>-->
              <div class="ticket-align item_block"
                   [ngClass]="{'sold-out-blur': (ticket?.limits.length < 1 || ticket.availability == 4),
                   'hideTicket': ( (hasRegularTicket && ticket.donation_type) || (hasDonateTicket && !ticket.donation_type) )}">

                <div class="ticket-photo" *ngIf="ticket?.nft_image_url">
                  <div class="ticket-img" [style.background-image]="'url(' + ticket?.nft_image_url + ')'"></div>
                </div>

                <div class="ticket-data">
                  <h4 class="category-ticket-title"
                      [ngClass]="{'disabled': ticket.availability == 2 || ticket.availability == 3 || ticket.availability == 4 }">
                    {{ticket.name}} <span i18n="@@PurchaseModal_soldout"
                                          *ngIf="ticket.availability == 2"> - Sold out</span>
                    <span i18n="item label | sold out" *ngIf="ticket.availability == 4"> - Sold out</span>
                  </h4>
                  <p [ngClass]="{'disabled': ticket.availability == 2 || ticket.availability == 3 || ticket.availability == 4 }"
                     class="ticket-price mb0" *ngIf="ticket.availability != 3 && !ticket.donation_type">
                    <span class="ticket-price-qnty">{{ticket.price | currency: currency:'symbol-narrow':'1.'}}</span>
                    <span i18n="item label | registration" *ngIf="ticket.reg == 1"> - Registration</span>
                  </p>

                  <!--Donation type-->
                  <div [ngClass]="{'disabled': ticket.availability == 2 || ticket.availability == 3 || ticket.availability == 4 }"
                       class="ticket-price" *ngIf="ticket.availability != 3 && ticket.donation_type">
                    <ng-container *ngIf="ticket?.limits.length > 0 && ticket.availability != 4">
                      <mat-form-field class="donate-form-field" [floatLabel]="'always'">
                        <mat-label>Amount</mat-label>
                        <input placeholder="0" matInput [disabled]="hasRegularTicket > 0" #ctrl="ngModel" type="number" (change)="donateChange($event, ticket, category.id)" (focus)="sendTheNewValue($event, category.id, j)" (input)="sendTheNewValue($event, category.id, j)" [min]="+ticket.donation_min" [max]="+ticket.donation_max" [step]="10" [(ngModel)]="ticket.price">
                        <span matTextPrefix>{{getCurrencySymbolF(currency)}}&nbsp;</span>
                        <button *ngIf="ticket.price" matSuffix mat-icon-button aria-label="Clear" class="btn-clear" (click)="ticket.price=0; clearDonate(ticket, category.id)">
                          <img src="/assets/images/svg-icons/close.svg" alt="clear">
                        </button>
                        <mat-error *ngIf="ctrl.errors?.min">Min: {{+ticket.donation_min}}</mat-error>
                        <mat-error *ngIf="ctrl.errors?.max">Max: {{+ticket.donation_max}}</mat-error>
                      </mat-form-field>
                    </ng-container>
                    <span *ngIf="ticket?.limits.length < 1 || ticket.availability == 4" class="ticket-price-qnty disabled-price">Sold out</span>
                    <span *ngIf="ticket?.limits.length > 0 && ticket.availability != 4 && !ticket.donation_type" class="ticket-price-qnty">{{ticket.price | currency: currency:currency === 'MXN' || currency === 'CAD' ? 'symbol': 'symbol-narrow':'1.':getLocale(currency)}}</span>
                  </div>

                  <div class="description-and-qty-selector">
                    <div class="ticket-description dim-description">
                      <p *ngIf="ticket.comment">{{ticket.comment}}</p>
                    </div>

                    <div class="ticket-amount" *ngIf="ticket?.limits.length > 0 && ticket?.availability == 1 && !ticket?.donation_type">

                      <div class="ticket-btn">
                        <div class="tickets-edit"
                             [ngClass]="{'sold-out-btn-hide': ticket?.limits.length < 1}"
                             (click)="choose(ticket,'plus', category.id, 1)">
                      <span class="sign-plus" [ngClass]="{'out-limits': (isAdmin?300:ticket?.limits.length) <= ticketLimits[ticket.id]['choosed'][category.id].amount}">
                        <svg width="17" height="16" viewBox="0 0 23 22"
                             fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.8422 10.6375V10.3375H21.5422H12.3371V1.27344V0.973437H12.0371H11.0866H10.7866V1.27344V10.3375H1.58154H1.28154V10.6375V11.5739V11.8739H1.58154H10.7866V20.9379V21.2379H11.0866H12.0371H12.3371V20.9379V11.8739H21.5422H21.8422V11.5739V10.6375Z" fill="#FF6465" stroke="#FF6465" stroke-width="0.6" />
                        </svg>
                      </span>
                        </div>
                      </div>

                      <span class="ticket-qnty">{{ticketLimits[ticket.id]['choosed'][category.id].amount}}</span>

                      <div class="ticket-btn">
                        <div class="tickets-edit"
                             [ngClass]="{'sold-out-btn-hide': ticket?.limits.length < 1}"
                             (click)="choose(ticket,'minus', category.id, 1)">
                      <span class="sign-minus">
                        <svg width="15" height="3" viewBox="0 0 23 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <line x1="0.862793" y1="1.03906" x2="22.2492" y2="1.03906" stroke="white" />
                        </svg>
                      </span>
                        </div>
                      </div>

                    </div>

                  </div>
                  <p class="ticket-date-start" i18n="item label | available soon"
                     *ngIf="ticket.availability == 3"
                     [ngClass]="{'disabled': ticket.availability == 2 || ticket.availability == 3 || ticket.availability == 4 }">Coming soon {{ticket.start_date}}</p>
                  <span class="ticket-date-start" *ngIf="( (hasRegularTicket && ticket.donation_type) || (hasDonateTicket && !ticket.donation_type) )">Please use a separate order for donation ticket and regular ticket</span>
                </div>



              </div>
<!--              <div [ngClass]="{'sold-out-blur': ticket?.limits.length < 1}" class="col-md-12 col-xs-12 total-tickets">-->
<!--                <span i18n="item label | total tickets">Total tickets</span>-->
<!--                <span class="tickets-qty">({{ticketLimits[ticket.id]['choosed'][category.id].amount}})</span>-->
<!--                <span>:{{total_price_w_commission}} {{currency}}</span>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-xs-12 item_block" [attr.item_id]="ticket.id"
        [ngClass]="{'disabled_bg': ticket.availability == 2 || ticket.availability == 3 || ticket.availability == 4 }"
        *ngFor="let ticket of withoutCategory; let k = index;">
        <div class="t">
<!--          <div [ngClass]="{'sold-out': (ticket?.limits.length < 1 || ticket.availability == 4)}"></div>-->
          <div class="ticket-align" [ngClass]="{'sold-out-blur': (ticket?.limits.length < 1 || ticket.availability == 4),
          'hideTicket': ( (hasRegularTicket && ticket.donation_type) || (hasDonateTicket && !ticket.donation_type) )}">

            <div class="ticket-photo" *ngIf="ticket?.nft_image_url">
              <div class="ticket-img" [style.background-image]="'url(' + ticket?.nft_image_url + ')'"></div>
            </div>

            <div class="ticket-data">
              <h4 class="category-ticket-title"
                  [ngClass]="{'disabled': ticket.availability == 2 || ticket.availability == 3 || ticket.availability == 4 }">
                {{ticket.name}}
                <span i18n="item label | sold out" *ngIf="ticket.availability == 2"> - Sold out</span>
                <span i18n="item label | sold out" *ngIf="ticket.availability == 4"> - Sold out</span>
<!--                availability == 4 - ticket Final End date is Up, availability == 2 - sold out-->
              </h4>
              <div [ngClass]="{'disabled': ticket.availability == 2 || ticket.availability == 3 || ticket.availability == 4 }"
                   class="ticket-price" *ngIf="ticket.availability != 3 && !ticket.donation_type">
                <span class="ticket-price-qnty">{{ticket.price | currency: currency :'symbol-narrow':'1.'}}</span>
                <span i18n="item label | registration" *ngIf="ticket.reg == 1"> - Registration</span>
              </div>


              <!--Donation type-->
              <div [ngClass]="{'disabled': ticket.availability == 2 || ticket.availability == 3 || ticket.availability == 4 }"
                   class="ticket-price" *ngIf="ticket.availability != 3 && ticket.donation_type">
                <ng-container *ngIf="ticket?.limits.length > 0 && ticket.availability != 4">
                  <mat-form-field class="donate-form-field" [floatLabel]="'always'">
                    <mat-label>Amount</mat-label>
                    <input placeholder="0" matInput [disabled]="hasRegularTicket > 0" #ctrl="ngModel" type="number" (change)="donateChange($event, ticket)" (focus)="sendTheNewValue($event, null, k)" (input)="sendTheNewValue($event, null, k)" [min]="+ticket.donation_min" [max]="+ticket.donation_max" [step]="10" [(ngModel)]="ticket.price">
                    <span matTextPrefix>{{getCurrencySymbolF(currency)}}&nbsp;</span>
                    <button *ngIf="ticket.price" matSuffix mat-icon-button aria-label="Clear" class="btn-clear" (click)="ticket.price=0; clearDonate(ticket)">
                      <img src="/assets/images/svg-icons/close.svg" alt="clear">
                    </button>
                    <mat-error *ngIf="ctrl.errors?.min">Min: {{+ticket.donation_min}}</mat-error>
                    <mat-error *ngIf="ctrl.errors?.max">Max: {{+ticket.donation_max}}</mat-error>
                  </mat-form-field>
                </ng-container>
                <span *ngIf="ticket?.limits.length < 1 || ticket.availability == 4" class="ticket-price-qnty disabled-price">Sold out</span>
                <span *ngIf="ticket?.limits.length > 0 && ticket.availability != 4 && !ticket.donation_type" class="ticket-price-qnty">{{ticket.price | currency: currency:currency === 'MXN' || currency === 'CAD' ? 'symbol': 'symbol-narrow':'1.':getLocale(currency)}}</span>
              </div>

              <div class="description-and-qty-selector">
                <div class="ticket-description dim-description">
                  <p *ngIf="ticket.comment">{{ticket.comment}}</p>
                </div>

                <div class="ticket-amount" *ngIf="ticket?.limits.length > 0 && ticket?.availability == 1 && !ticket?.donation_type">

                  <div class="ticket-btn">
                    <div class="tickets-edit"
                         [ngClass]="{'sold-out-btn-hide': ticket?.limits.length < 1}"
                         (click)="choose(ticket,'plus', null, 1)">
                      <span class="sign-plus" [ngClass]="{'out-limits': (isAdmin?300:ticket?.limits.length) <= ticketLimits[ticket.id]['choosed']['noCat'].amount}">
                        <svg width="17" height="16" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M21.8422 10.6375V10.3375H21.5422H12.3371V1.27344V0.973437H12.0371H11.0866H10.7866V1.27344V10.3375H1.58154H1.28154V10.6375V11.5739V11.8739H1.58154H10.7866V20.9379V21.2379H11.0866H12.0371H12.3371V20.9379V11.8739H21.5422H21.8422V11.5739V10.6375Z" fill="#FF6465" stroke="#FF6465" stroke-width="0.6" />
                        </svg>
                      </span>
                    </div>
                  </div>

                  <span class="ticket-qnty">{{ticketLimits[ticket.id]['choosed']['noCat'].amount}}</span>

                  <div class="ticket-btn">
                    <div class="tickets-edit"
                         [ngClass]="{'sold-out-btn-hide': ticket?.limits.length < 1}"
                         (click)="choose(ticket,'minus', null, 1)">
                      <span class="sign-minus">
                        <svg width="15" height="3" viewBox="0 0 23 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <line x1="0.862793" y1="1.03906" x2="22.2492" y2="1.03906" stroke="white" />
                        </svg>
                      </span>
                    </div>
                  </div>

                </div>

              </div>

              <p class="ticket-date-start" i18n="item label | available soon"
                 *ngIf="ticket.availability == 3"
                 [ngClass]="{'disabled': ticket.availability == 2 || ticket.availability == 3 || ticket.availability == 4 }">Coming soon {{ticket.start_date}}
              </p>
              <span class="ticket-date-start" *ngIf="( (hasRegularTicket && ticket.donation_type) || (hasDonateTicket && !ticket.donation_type) )">Please use a separate order for donation ticket and regular ticket</span>
            </div>

          </div>
<!--          <span *ngIf="ticket.comment" [ngClass]="{'sold-out-blur': ticket?.limits.length < 1}"-->
<!--            class="col-md-12 col-xs-12 text-center">{{ticket.comment}}</span>-->
<!--            <div [ngClass]="{'sold-out-blur': ticket?.limits.length < 1}" class="col-md-12 col-xs-12 total-tickets">-->
<!--              <span i18n="item label | total tickets">Total tickets</span>-->
<!--              <span class="tickets-qty">({{ticketLimits[ticket.id]['choosed']['noCat'].amount}})</span>-->
<!--              <span>:{{total_price_w_commission}} {{currency}}</span>-->
<!--            </div>-->
        </div>
      </div>
    </div>
    <!-- rooms category: -->
    <div *ngIf="purchase_item === 2" class="room_items">
      <div class="item_block"
        [ngClass]="{'disabled_bg': room.availability == 2 || room.availability == 3 || room.availability == 4 }"
        *ngFor="let room of rooms">
        <div class="t">
          <div class="col-md-2 col-xs-2 quantity-minus">
            <div *ngIf="room?.limits.length > 0 && room?.availability == 1" class="ticket-btn">
              <div class="tickets-edit" [ngClass]="{'sold-out-btn-hide': room?.limits.length < 1}"
                (click)="choose(room,'minus', null, 2)"><span class="sign-minus">
                  <svg width="23" height="2" viewBox="0 0 23 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line x1="0.862793" y1="1.03906" x2="22.2492" y2="1.03906" stroke="white" />
                  </svg>
                </span></div>
            </div>
          </div>
          <div class="col-md-8 col-xs-8">
            <div class="ticket-title"
              [ngClass]="{'disabled': room.availability == 2 || room.availability == 3 || room.availability == 4 }">
              {{room.name}} <span i18n="@@PurchaseModal_soldout" *ngIf="room.availability == 2"> - Sold out</span><span
                i18n="@@PurchaseModal_ticketExpired" *ngIf="room.availability == 4"> - Ticket expired</span></div>
            <p [ngClass]="{'disabled': room.availability == 2 || room.availability == 3 || room.availability == 4 }"
              class="ticket-price mb0" *ngIf="room.availability != 3">
              {{room.price_with_commission | currency: currency}}<span i18n="@@PurchaseModal_registration"
                *ngIf="room.reg == 1"> - Registration</span></p>
            <!-- <p><span *ngIf="room.reg != 1" class="disabled priceDescription">(מחיר {{room.price | currency: currency}} עמלת סליקה: {{room.price_with_commission - room.price | number:'1.0-2' | currency: currency}})</span></p> -->
            <!-- <p *ngIf="room.reg != 1 && room.availability != 3 && room.price_with_commission != room.price" class="disabled priceDescription">
                (<span i18n="item label | price with commission">מחיר כולל דמי טיפול של</span> {{room.price_with_commission - room.price | number:'1.0-2' | currency: currency}})
              </p> -->
            <p class="ticket-text" *ngIf="room.availability == 3"
              [ngClass]="{'disabled': room.availability == 2 || room.availability == 3 || room.availability == 4 }">
              <span i18n="@@PurchaseModal_ComingSoon">Coming soon</span> {{room.start_date}}</p>
          </div>
          <div class="col-md-2 col-xs-2 quantity-plus">
            <div *ngIf="room?.limits.length > 0 && room?.availability == 1" class="ticket-btn">
              <div [ngClass]="{'sold-out-btn-hide': room?.limits.length < 1}" class="tickets-edit"
                (click)="choose(room,'plus', null, 2)">
                <span class="sign-plus"
                  [ngClass]="{'out-limits': isAdmin?300:room?.limits.length <= ticketLimits[room.id]['choosed']['noCat'].amount}">
                  <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M21.8422 10.6375V10.3375H21.5422H12.3371V1.27344V0.973437H12.0371H11.0866H10.7866V1.27344V10.3375H1.58154H1.28154V10.6375V11.5739V11.8739H1.58154H10.7866V20.9379V21.2379H11.0866H12.0371H12.3371V20.9379V11.8739H21.5422H21.8422V11.5739V10.6375Z"
                      fill="#FF6465" stroke="#FF6465" stroke-width="0.6" />
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <!-- choose room / quantity: -->
          <!-- <div *ngIf="room?.limits.length > 0 && room?.availability == 1" class="col-md-4 col-xs-4 room_selection"> -->
          <!-- select option for room with NO defined limit (system shows up to 20 rooms - not for sold out or closed rooms): -->
          <!-- <select (change)="choose(room, item.value, 2)" #item class="form-control" name="quantity">
                <option i18n="select quantity" [selected]="toggleItem != room.id" [value]="null">כמות</option>
                <option [id]="room.id" *ngFor="let qty of room.limits; let currentElementIndex=index" [value]="qty">{{qty}}</option>
              </select>
            </div> -->
        </div>
        <!-- <span *ngIf="room.comment" class="col-md-12 col-xs-12 text-center">{{room.comment}}</span> -->
        <span *ngIf="room.comment" [ngClass]="{'sold-out-blur': room?.limits.length < 1}"
          class="col-md-12 col-xs-12 text-center">{{room.comment}}</span>
          <div [ngClass]="{'sold-out-blur': room?.limits.length < 1}" class="col-md-12 col-xs-12 total-tickets">
            <span i18n="item label | total tickets" >Total tickets</span>
            <span class="tickets-qty">({{ticketLimits[room.id]['choosed']['noCat'].amount}})</span>
            <span>:{{total_price_w_commission}} {{currency}}</span>
          </div>
      </div>
    </div>
    <!-- tables category: -->
    <div *ngIf="purchase_item === 3" class="table_items">
      <div class="item_block"
        [ngClass]="{'disabled_bg': table.availability == 2 || table.availability == 3 || table.availability == 4 }"
        *ngFor="let table of tables">
        <div class="col-md-12 col-xs-12 vertical-align">
          <div class="col-md-2 col-xs-2 quantity-minus">-</div>
          <!-- table name and price -->
          <div class="col-md-8 col-xs-8">
            <div class="ticket-title"
              [ngClass]="{'disabled': table.availability == 2 || table.availability == 3 || table.availability == 4 }">
              {{table.name}} <span i18n="@@PurchaseModal_soldout" *ngIf="table.availability == 2"> - Sold out</span><span
                i18n="@@PurchaseModal_ticketExpired" *ngIf="table.availability == 4"> - Ticket expired</span></div>
            <p [ngClass]="{'disabled': table.availability == 2 || table.availability == 3 || table.availability == 4 }"
              class="ticket-price mb0" *ngIf="table.availability != 3">
              {{table.price_with_commission | currency: currency}}<span i18n="@@PurchaseModal_registration"
                *ngIf="table.reg == 1"> - Registration</span></p>
            <!-- <p><span *ngIf="table.reg != 1" class="disabled priceDescription">(מחיר {{table.price | currency: currency}} עמלת סליקה: {{table.price_with_commission - table.price | number:'1.0-2' | currency: currency}})</span></p> -->
            <!-- <p *ngIf="table.reg != 1  && table.availability != 3 && table.price_with_commission != table.price" class="disabled priceDescription">
                (<span i18n="item label | price with commission">מחיר כולל דמי טיפול של</span> {{table.price_with_commission - table.price | number:'1.0-2' | currency: currency}})
              </p> -->
            <p class="ticket-text" *ngIf="table.availability == 3"
              [ngClass]="{'disabled': table.availability == 2 || table.availability == 3 || table.availability == 4 }">
              <span i18n="@@PurchaseModal_ComingSoon">Coming soon</span>{{table.start_date}}</p>
          </div>
          <div class="col-md-2 col-xs-2 quantity-plus">+</div>
          <!-- choose table / quantity: -->
          <!-- <div *ngIf="table?.limits.length > 0 && table?.availability == 1" class="col-md-4 col-xs-4 table_selection"> -->
          <!-- select option for table with NO defined limit (system shows up to 20 tables - not for sold out or closed tables): -->
          <!-- <select (change)="choose(table, item.value, 3)" #item class="form-control" name="quantity">
                <option i18n="select quantity" [selected]="toggleItem != table.id" [value]="null">כמות</option>
                <option [id]="table.id" *ngFor="let qty of table.limits; let currentElementIndex=index" [value]="qty">{{qty}}</option>
              </select>
            </div> -->
        </div>
        <span *ngIf="table.comment" class="col-md-12 col-xs-12 text-center">{{table.comment}}</span>
      </div>
    </div>
    <button (click)="toParticipantData()" class="continue"
      [class.disabledButton]="!ticketsAvailability && !isFromEventPayment" *ngIf="!showSeatsIo">
<!--      <span i18n="next screen button" class="continue_text">הבא</span>-->
      <div class="button-text-upper-nui">
        <p i18n="payment button | continue" class="purchase-btn-continue mb0">continue</p>
      </div>
      <div class="purchase-btn-total"
           *ngIf="quantity"
           [ngStyle]="{'border-right': dir == 'rtl' ? '1px solid rgba(255, 255, 255, 0.3)' : 'none',
           'border-left': dir == 'rtl' ? 'none' : '1px solid rgba(255, 255, 255, 0.3)'}">
        <p class="purchase-btn-total-tickets">{{quantity}}&nbsp;<span i18n="purchase-btn-total">{quantity, plural, =1 {ticket} other {tickets}}</span></p>
        <p class="purchase-btn-total-price">{{total_price_n_commission | currency: currency:'symbol-narrow':'1.0'}}</p>
      </div>
    </button>
  </div>
  <div class="participant_details" [hidden]="step != 'participant_details'">
    <div *ngIf="!full_purchase && !eventPaymentMode" class="close_modal">
      <div class="col-md-12 col-xs-12">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div class="row return_to_tickets mt15" (click)="returnTo('items_section', 'init', true)">
      <div class="col-md-12 col-xs-12">
        <i class="fa {{faAngleRightRtlLeftLtr}} disabled icon-nav-size"></i>
      </div>
      <!-- <div class="col-md-10 col-xs-10">
        <p id="item_category" class="disabled"></p>
      </div> -->
    </div>
    <div class="ticket_body col-md-12 col-xs-12 mt20">
      <form [formGroup]="participantForm">
        <div *ngIf="purchase_type === 1">
          <ng-container *ngIf="showSeatsIo && purchase_type === 1"> <!--SEATSIO TIckets list-->
            <div style="border: 1px solid rgba(255,255,255,0.32);border-radius: 16px; padding: 10px;" *ngIf="participantForm.controls['participants']['controls'][0] !== undefined">
              <div class="guest-complete-text2" *ngFor="let labels of participantForm.controls['participants']['controls'][0].get('labels')['controls']">
                <p class="seats-t-info" *ngFor="let label of labels.value | keyvalue">{{+label.key + 1}}.
                  <!--                          <span *ngIf="label.value.section">Section: {{label.value.section}}</span>&nbsp;-->
                  <span *ngIf="label.value.parent">
                  <span i18n="seats|Row" *ngIf="label.value.type === 'row'">Row: </span>
                  <span i18n="seats|Table" *ngIf="label.value.type === 'table'">Table: </span>
                    {{label.value.parent}}</span>&nbsp;
                  <span *ngIf="label.value.own"><span i18n="seats|Seat"> Seat: </span>{{label.value.own}}</span>&nbsp;
                </p>
              </div>
            </div>
          </ng-container>

          <div id="item-{{i + 1}}" formArrayName="participants"
            *ngFor="let item of participantForm?.get('participants')['controls']; let i = index">
            <div [formGroupName]="i" #participant>
              <div (click)="toggleParticipantForm(i + 1)"
                [class.participant-invalid]="participantForm.controls['participants']['controls'][i].invalid && formSubmited"
                class="validation_block  mb10 col-md-12 col-xs-12">
                <div class="col-md-12 col-xs-12 vertical-align pl0 dropdown-attendee align-name">
                  <div class="attendee-avatar">
                    <img width="20" src="/assets/images/landingPage/User.png">
                  </div>
                  <div class="attendee-name">
                    <p i18n="item label | attendee details" *ngIf="item.invalid" id="cardName1" class="mb0"> Edit attendee details <span class="participant_counter">{{ i + 1}}</span></p>
                    <p *ngIf="item.valid" id="cardName" class="mb0">{{item.controls.full_name.value}}</p>
                  </div>
                  <span *ngIf="item.valid" class="sign-complete-nui">
                    <svg class="card-cb-on-nui" width="12" height="8" viewBox="0 0 12 8" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M11.8243 0.159541C11.59 -0.0531803 11.2101 -0.0531803 10.9757 0.159541L3.78737 6.68516L1.02428 4.17684C0.789972 3.96412 0.410097 3.96414 0.175746 4.17684C-0.058582 4.38954 -0.058582 4.73439 0.175746 4.94711L3.3631 7.84053C3.59734 8.05323 3.97749 8.05308 4.21163 7.84053L11.8243 0.929831C12.0586 0.717131 12.0586 0.372262 11.8243 0.159541Z"
                        fill="#82FFCA" />
                    </svg>
                  </span>
                  <span *ngIf="!item.valid" class="sign-complete-nui"></span>
                </div>
              </div>
              <div *ngIf="toggleParticipant === i + 1" [@slideIn] class="form_item pt10 col-md-12 col-xs-12">
                <ng-container *ngIf="isAdmin">
                  <div class="autofill-container">
                    <div class="search-events">
                      <button class="search-btn"  aria-label="search" (click)="toggleSearch()" [ngClass]="{'active': showSearchInput}">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M17.1544 15.0935H16.0649L15.6862 14.7175C17.0241 13.1574 17.8377 11.1349 17.8377 8.91887C17.8377 3.99291 13.8448 0 8.91887 0C3.99291 0 0 3.99291 0 8.91887C0 13.8448 3.99291 17.8377 8.91887 17.8377C11.1349 17.8377 13.156 17.0254 14.7161 15.689L15.0949 16.0649V17.1517L21.9528 24L23.9986 21.9541L17.1544 15.0935ZM8.91888 15.0935C5.50776 15.0935 2.74428 12.33 2.74428 8.91888C2.74428 5.50913 5.50776 2.74428 8.91888 2.74428C12.3286 2.74428 15.0935 5.50913 15.0935 8.91888C15.0935 12.33 12.3286 15.0935 8.91888 15.0935Z"
                                fill="#dadada" />
                        </svg>
                      </button>
                      <div class="search-filter" *ngIf="showSearchInput">
                        <input i18n-placeholder="@@SearchEvents" type="search" id="searchInput" class="search-input"
                               (input)="searchFilter($event)" [(ngModel)]="filterText" (keydown)="inputChanged($event)"
                               [ngModelOptions]="{standalone: true}" name="search" placeholder="Search Events">
                      </div>
                    </div>
                    <span i18n="purchase modal | fill with my data" class="auto-fill" (click)="fillForMe(i)"
                          *ngIf="(!!user_info && item.invalid && !showSearchInput)">Auto fill</span>
                    <span i18n="@@Clearattendeedetails" class="auto-clear" (click)="clearAttendee(i)"
                          *ngIf="(!!user_info && item.valid && !showSearchInput)">Clear attendee details</span>
                  </div>
                  <div *ngIf="searchAttendeeResult.length && showSearchInput" class="search-result">
                    <div class="searched-attendee" *ngFor="let user of searchAttendeeResult; let a = index"
                         (click)="fillAttendee(a, i, user)">
                      <div class="round-user-avatar">
                        <img class="blur" src="/assets/images/userImage1.jpg">
                      </div>
                      <div class="searched-user">{{user.first_name}}</div>
                      <span *ngIf="attendee_index == a" class="sign-complete-nui">
                      <svg class="card-cb-on-nui" width="12" height="8" viewBox="0 0 12 8" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M11.8243 0.159541C11.59 -0.0531803 11.2101 -0.0531803 10.9757 0.159541L3.78737 6.68516L1.02428 4.17684C0.789972 3.96412 0.410097 3.96414 0.175746 4.17684C-0.058582 4.38954 -0.058582 4.73439 0.175746 4.94711L3.3631 7.84053C3.59734 8.05323 3.97749 8.05308 4.21163 7.84053L11.8243 0.929831C12.0586 0.717131 12.0586 0.372262 11.8243 0.159541Z"
                          fill="#82FFCA" />
                      </svg>
                    </span>
                    </div>
                  </div>
                </ng-container>
                <!-- <div class="attendee-buttons row">
                    <button i18n="purchase modal | Fill with my data" class="btn btn-primary" (click)="fillForMe(i)" *ngIf="user_info && participantForm.controls['participants']['controls'][i].invalid">
                      מלא עם הפרטים שלי
                    </button>
                    <button i18n="Clear attendee details" class="btn btn-danger" (click)="clearAttendee(i)">
                      מחק פרטי משתתף
                    </button>
                  </div> -->
                <!-- Default inputs -->
                <div *ngFor="let input of form_inputs?.default_inputs">
                  <app-form-inputs *ngIf="input.required != '0'" ngDefaultControl (age)="ageToDate($event)"
                    (selectInput)="selectHandler($event)" (radio)="radioHandler($event)"
                    (checkbox)="checkboxHandler($event)" [eventPaymentMode]="eventPaymentMode"
                    [form]="participantForm.controls['participants']['controls'][i]" [input]="input" [counter]="i"
                    [ageDisplay]="event_details?.age_display"
                    [birth_date]="event_details?.birth_date"
                    [gender]="event_details?.gender"
                    [id_number]="event_details?.id_number"
                    [customClass]="'mt10 mb10 col-md-12 col-xs-12'">
                  </app-form-inputs>
                  <!-- Errors handling -->
                  <app-error-handling *ngIf="input.required != '0' && input.input_name !== 'age'" ngDefaultControl
                    [formControl]="participantForm.controls['participants']['controls'][i].controls[input.input_name]"
                    [inputName]="input.input_name" [formSubmited]="formSubmited"
                    [customClass]="'error col-md-12 col-xs-12 item-error'">
                  </app-error-handling>
                </div>

                <!-- For instagram_url input -->
                <div *ngIf="event_details.instagram_url === 1">
                  <div class="cards-nui" [formGroup]="participantForm.controls['participants']['controls'][i]">
                    <label i18n="input label | instagram_url" *ngIf="false"
                           for="instagram_url"></label>
                    <input class="guest-input-text-nui form-control" trim="blur"
                           id="instagram_url" type="text"
                           name="instagram_url" formControlName="instagram_url"
                           placeholder="Instagram" i18n-placeholder>
                  </div>
                  <app-error-handling [@slideIn] *ngIf="event_details.instagram_url === 1" ngDefaultControl
                                      [formControl]="participantForm.controls['participants']['controls'][i].controls['instagram_url']" [inputName]="'instagram_url'"
                                      [formSubmited]="formSubmited" [customClass]="'error item-error'">
                  </app-error-handling>
                </div>


                <!-- NEW Custom inputs -->
                <ng-container *ngFor="let input of new_custom_inputs; let k = index;">
                  <app-custom-form-inputs *ngIf="!input.blocked" class="section-item-end" style="width: 100%;" ngDefaultControl
                                          (selectInput)="selectHandler($event)"
                                          (radio)="cf_radioHandler(k,i,$event)"
                                          (checkbox)="checkboxHandler($event)"
                                          [form]="item"
                                          [input]="input"
                                          [counter]="i"
                                          [customClass]="'mt10 mb10 col-md-12 col-xs-12'">
                  </app-custom-form-inputs>

                  <app-error-handling *ngIf="!input.blocked" class="section-item-end" ngDefaultControl
                                      [formControl]="item.controls[input.id]"
                                      [inputName]="input.title" [formSubmited]="formSubmited"
                                      [customClass]="'error col-md-12 col-xs-12 item-error'">
                  </app-error-handling>
                </ng-container>

              </div>
            </div>
          </div>
        </div>
        <div *ngIf="purchase_type !== 1">
          <div *ngFor="let category of choosedItems | keyvalue">
            <div class="form-category mb10" *ngIf="category.key != 'noCat'">
              <p class="category-name">{{category.value.name}}</p>
              <div class="form-ticket-wrap" *ngFor="let ticket of category.value | keyvalue">
                <div class="form-ticket mb10" *ngIf="ticket.key !== 'name'">
                  <p class="ticket-name">{{ticket.value.name}}</p>
                  <div id="item-{{i + 1}}" formArrayName="participants"
                    *ngFor="let item of participantForm?.get('participants')['controls']; let i = index;">

                    <div class="guest-complete-text" style="padding: 0 15px;"  *ngIf="showSeatsIo && purchase_type !== 1"> <!--SEATSIO TIckets list-->
                      <!--                                  <p class="seats-label" *ngIf="item.contains('labels')">Ticket: {{item.controls.labels.controls.displayedLabel.value}}</p>-->
                      <p class="seats-t-info" *ngIf="item.contains('labels')">
                        <!--                                    <span *ngIf="item.controls.labelsi18n="seats|Row".contains('section')">Section: {{item.controls.labels.controls.section.value}}</span>&nbsp;-->
                        <span *ngIf="item.controls.labels.contains('parent')">
                          <span i18n="seats|Row" *ngIf="item.controls.labels.controls.type.value === 'row'">Row: </span>
                          <span i18n="seats|Table" *ngIf="item.controls.labels.controls.type.value === 'table'">Table: </span>
                          {{item.controls.labels.controls.parent.value}}</span>&nbsp;
                        <span *ngIf="item.controls.labels.contains('own')"><span i18n="seats|Seat"> Seat: </span>{{item.controls.labels.controls.own.value}}</span>&nbsp;
                      </p>
                    </div>

                    <div [formGroupName]="i" #participant
                      *ngIf="item.controls.item_id.value == ticket.key && item.controls.category.value == category.key">
                      <div (click)="toggleParticipantForm(i + 1)"
                        [class.participant-invalid]="participantForm.controls['participants']['controls'][i].invalid && formSubmited"
                        class="validation_block  mb10 col-md-12 col-xs-12">
                        <div class="vertical-align pl0 dropdown-attendee">
                          <div class="attendee-avatar">
                            <img width="20" src="/assets/images/landingPage/User.png">
                          </div>
                          <div class="attendee-name">
                            <p i18n="item label | attendee details" *ngIf="item.invalid" id="cardName2" class="mb0"> Edit attendee details <span class="participant_counter">{{ i + 1}}</span></p>
                            <p *ngIf="item.valid" id="cardName" class="mb0">{{item.controls.full_name.value}}</p>
                          </div>
                          <span *ngIf="item.valid" class="sign-complete-nui">
                            <svg class="card-cb-on-nui" width="12" height="8" viewBox="0 0 12 8" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M11.8243 0.159541C11.59 -0.0531803 11.2101 -0.0531803 10.9757 0.159541L3.78737 6.68516L1.02428 4.17684C0.789972 3.96412 0.410097 3.96414 0.175746 4.17684C-0.058582 4.38954 -0.058582 4.73439 0.175746 4.94711L3.3631 7.84053C3.59734 8.05323 3.97749 8.05308 4.21163 7.84053L11.8243 0.929831C12.0586 0.717131 12.0586 0.372262 11.8243 0.159541Z"
                                fill="#82FFCA" />
                            </svg>
                          </span>
                          <span *ngIf="!item.valid" class="sign-complete-nui"></span>
                        </div>
                      </div>
                      <div *ngIf="toggleParticipant === i + 1" [@slideIn] class="form_item pt10 col-md-12 col-xs-12">
                        <div class="autofill-container">
                          <div class="search-events" *ngIf="isAdmin">
                            <button class="search-btn" aria-label="search" (click)="toggleSearch()" [ngClass]="{'active': showSearchInput}">
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M17.1544 15.0935H16.0649L15.6862 14.7175C17.0241 13.1574 17.8377 11.1349 17.8377 8.91887C17.8377 3.99291 13.8448 0 8.91887 0C3.99291 0 0 3.99291 0 8.91887C0 13.8448 3.99291 17.8377 8.91887 17.8377C11.1349 17.8377 13.156 17.0254 14.7161 15.689L15.0949 16.0649V17.1517L21.9528 24L23.9986 21.9541L17.1544 15.0935ZM8.91888 15.0935C5.50776 15.0935 2.74428 12.33 2.74428 8.91888C2.74428 5.50913 5.50776 2.74428 8.91888 2.74428C12.3286 2.74428 15.0935 5.50913 15.0935 8.91888C15.0935 12.33 12.3286 15.0935 8.91888 15.0935Z"
                                  fill="#dadada" />
                              </svg>
                            </button>
                            <div class="search-filter" *ngIf="showSearchInput">
                              <input i18n-placeholder="@@SearchEvents" type="search" id="searchInput"
                                class="search-input" (input)="searchFilter($event)" (keydown)="inputChanged($event)"
                                [(ngModel)]="filterText" [ngModelOptions]="{standalone: true}" name="search"
                                placeholder="Search Events">
                            </div>
                          </div>
                          <span i18n="purchase modal | Fill with my data" class="auto-fill" (click)="fillForMe(i)"
                            *ngIf="(!!user_info && participantForm.controls['participants']['controls'][i].invalid && !showSearchInput)">Auto fill</span>
                          <span i18n="@@Clearattendeedetails" class="auto-clear" (click)="clearAttendee(i)"
                            *ngIf="(!!user_info && participantForm.controls['participants']['controls'][i].valid && !showSearchInput)">Clear attendee details</span>
                        </div>
                        <div *ngIf="searchAttendeeResult.length && showSearchInput" class="search-result">
                          <div class="searched-attendee" *ngFor="let user of searchAttendeeResult; let a = index"
                            (click)="fillAttendee(a, i, user)">
                            <div class="round-user-avatar">
                              <img class="blur" src="/assets/images/userImage1.jpg">
                            </div>
                            <div class="searched-user">{{user.first_name}}</div>
                            <span *ngIf="attendee_index == a" class="sign-complete-nui">
                              <svg class="card-cb-on-nui" width="12" height="8" viewBox="0 0 12 8" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M11.8243 0.159541C11.59 -0.0531803 11.2101 -0.0531803 10.9757 0.159541L3.78737 6.68516L1.02428 4.17684C0.789972 3.96412 0.410097 3.96414 0.175746 4.17684C-0.058582 4.38954 -0.058582 4.73439 0.175746 4.94711L3.3631 7.84053C3.59734 8.05323 3.97749 8.05308 4.21163 7.84053L11.8243 0.929831C12.0586 0.717131 12.0586 0.372262 11.8243 0.159541Z"
                                  fill="#82FFCA" />
                              </svg>
                            </span>
                          </div>
                        </div>
                        <!-- <div class="attendee-buttons row">
                            <button i18n="purchase modal | Fill with my data" class="btn btn-primary" (click)="fillForMe(i)" *ngIf="user_info && participantForm.controls['participants']['controls'][i].invalid">
                              מלא עם הפרטים שלי
                            </button>
                            <button i18n="Clear attendee details" class="btn btn-danger" (click)="clearAttendee(i)">
                              מחק פרטי משתתף
                            </button>
                          </div> -->
                        <!-- Default inputs -->
                        <div *ngFor="let input of form_inputs?.default_inputs">
                          <app-form-inputs *ngIf="input.required != '0'" ngDefaultControl (age)="ageToDate($event)"
                            (selectInput)="selectHandler($event)" (radio)="radioHandler($event)"
                            (checkbox)="checkboxHandler($event)" [eventPaymentMode]="eventPaymentMode"
                            [form]="participantForm.controls['participants']['controls'][i]" [input]="input"
                            [counter]="i" [ageDisplay]="event_details?.age_display"
                            [birth_date]="event_details?.birth_date"
                            [gender]="event_details?.gender"
                            [id_number]="event_details?.id_number"
                            [customClass]="'mt10 mb10 col-md-12 col-xs-12'">
                          </app-form-inputs>
                          <!-- Errors handling -->
                          <app-error-handling *ngIf="input.required != '0' && input.input_name !== 'age'" ngDefaultControl
                            [formControl]="participantForm.controls['participants']['controls'][i].controls[input.input_name]"
                            [inputName]="input.input_name" [formSubmited]="formSubmited"
                            [customClass]="'error col-md-12 col-xs-12 item-error'">
                          </app-error-handling>
                        </div>


                        <!-- For instagram_url input -->
                        <div *ngIf="event_details.instagram_url === 1">
                          <div class="cards-nui" [formGroup]="participantForm.controls['participants']['controls'][i]">
                            <label i18n="input label | instagram_url" *ngIf="false"
                                   for="instagram_url"></label>
                            <input class="guest-input-text-nui form-control" trim="blur"
                                   id="instagram_url" type="text"
                                   name="instagram_url" formControlName="instagram_url"
                                   placeholder="Instagram" i18n-placeholder>
                          </div>
                          <app-error-handling [@slideIn] *ngIf="event_details.instagram_url === 1" ngDefaultControl
                                              [formControl]="participantForm.controls['participants']['controls'][i].controls['instagram_url']" [inputName]="'instagram_url'"
                                              [formSubmited]="formSubmited" [customClass]="'error item-error'">
                          </app-error-handling>
                        </div>


                        <!-- NEW Custom inputs -->
                        <ng-container *ngFor="let input of new_custom_inputs; let k = index;">
                          <app-custom-form-inputs *ngIf="!input.blocked" class="section-item-end" style="width: 100%;" ngDefaultControl
                                                  (selectInput)="selectHandler($event)"
                                                  (radio)="cf_radioHandler(k,i,$event)"
                                                  (checkbox)="checkboxHandler($event)"
                                                  [form]="item"
                                                  [input]="input"
                                                  [counter]="i"
                                                  [customClass]="'mt10 mb10 col-md-12 col-xs-12'">
                          </app-custom-form-inputs>

                          <app-error-handling *ngIf="!input.blocked" class="section-item-end" ngDefaultControl
                                              [formControl]="item.controls[input.id]"
                                              [inputName]="input.title" [formSubmited]="formSubmited"
                                              [customClass]="'error col-md-12 col-xs-12 item-error'">
                          </app-error-handling>
                        </ng-container>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-category form-ticket-wrap" *ngFor="let ticket of choosedItems['noCat'] | keyvalue">
            <div class="form-ticket mb10" *ngIf="ticket.key !== 'name'">
              <p class="ticket-name">{{ticket.value.name}}</p>
              <div id="item-{{i + 1}}" formArrayName="participants"
                *ngFor="let item of participantForm?.get('participants')['controls']; let i = index">
                <div class="guest-complete-text" style="padding:0 15px;"  *ngIf="showSeatsIo && purchase_type !== 1"> <!--SEATSIO TIckets list-->
                  <!--                                  <p class="seats-label" *ngIf="item.contains('labels')">Ticket: {{item.controls.labels.controls.displayedLabel.value}}</p>-->
                  <p class="seats-t-info" *ngIf="item.contains('labels')">
                    <!--                                    <span *ngIf="item.controls.labels.contains('section')">Section: {{item.controls.labels.controls.section.value}}</span>&nbsp;-->
                    <span *ngIf="item.controls.labels.contains('parent')">
                      <span i18n="seats|Row" *ngIf="item.controls.labels.controls.type.value === 'row'">Row: </span>
                      <span i18n="seats|Table" *ngIf="item.controls.labels.controls.type.value === 'table'">Table: </span>
                      {{item.controls.labels.controls.parent.value}}</span>&nbsp;
                    <span *ngIf="item.controls.labels.contains('own')"><span i18n="seats|Seat"> Seat: </span>{{item.controls.labels.controls.own.value}}</span>&nbsp;
                  </p>
                </div>
                <div [formGroupName]="i" #participant *ngIf="item.controls.item_id.value == ticket.key">
                  <div (click)="toggleParticipantForm(i + 1)"
                    [class.participant-invalid]="participantForm.controls['participants']['controls'][i].invalid && formSubmited"
                    class="validation_block  mb10 col-md-12 col-xs-12">
                    <div class="col-md-12 col-xs-12 vertical-align pl0 dropdown-attendee align-name">
                      <div class="attendee-avatar">
                        <img width="20" src="/assets/images/landingPage/User.png">
                      </div>
                      <div class="attendee-name">
                        <p i18n="item label | attendee details" *ngIf="item.invalid" id="cardName3" class="mb0"> Edit attendee details <span class="participant_counter">{{ i + 1}}</span></p>
                        <p *ngIf="item.valid" id="cardName" class="mb0">{{item.controls.full_name.value}}</p>
                      </div>
                      <span *ngIf="item.valid" class="sign-complete-nui">
                        <svg class="card-cb-on-nui" width="12" height="8" viewBox="0 0 12 8" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M11.8243 0.159541C11.59 -0.0531803 11.2101 -0.0531803 10.9757 0.159541L3.78737 6.68516L1.02428 4.17684C0.789972 3.96412 0.410097 3.96414 0.175746 4.17684C-0.058582 4.38954 -0.058582 4.73439 0.175746 4.94711L3.3631 7.84053C3.59734 8.05323 3.97749 8.05308 4.21163 7.84053L11.8243 0.929831C12.0586 0.717131 12.0586 0.372262 11.8243 0.159541Z"
                            fill="#82FFCA" />
                        </svg>
                      </span>
                      <span *ngIf="!item.valid" class="sign-complete-nui"></span>
                    </div>
                  </div>
                  <div *ngIf="toggleParticipant === i + 1" [@slideIn] class="form_item pt10 col-md-12 col-xs-12">
                    <div class="autofill-container">
                      <div class="search-events" *ngIf="isAdmin">
                        <button class="search-btn" aria-label="search" (click)="toggleSearch()" [ngClass]="{'active': showSearchInput}">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M17.1544 15.0935H16.0649L15.6862 14.7175C17.0241 13.1574 17.8377 11.1349 17.8377 8.91887C17.8377 3.99291 13.8448 0 8.91887 0C3.99291 0 0 3.99291 0 8.91887C0 13.8448 3.99291 17.8377 8.91887 17.8377C11.1349 17.8377 13.156 17.0254 14.7161 15.689L15.0949 16.0649V17.1517L21.9528 24L23.9986 21.9541L17.1544 15.0935ZM8.91888 15.0935C5.50776 15.0935 2.74428 12.33 2.74428 8.91888C2.74428 5.50913 5.50776 2.74428 8.91888 2.74428C12.3286 2.74428 15.0935 5.50913 15.0935 8.91888C15.0935 12.33 12.3286 15.0935 8.91888 15.0935Z"
                              fill="#dadada" />
                          </svg>
                        </button>
                        <div class="search-filter" *ngIf="showSearchInput">
                          <input i18n-placeholder="@@SearchEvents" type="search" id="searchInput"
                            class="search-input" (input)="searchFilter($event)" [(ngModel)]="filterText"
                            (keydown)="inputChanged($event)" [ngModelOptions]="{standalone: true, debounce: 1000}"
                            name="search" placeholder="Search Events">
                        </div>
                      </div>
                      <span i18n="purchase modal | Fill with my data" class="auto-fill" (click)="fillForMe(i)"
                        *ngIf="(!!user_info && participantForm.controls['participants']['controls'][i].invalid  && !showSearchInput)">Auto fill</span>
                      <span i18n="@@PurchaseModalClearAttendeeDetails" class="auto-clear" (click)="clearAttendee(i)"
                        *ngIf="(!!user_info && participantForm.controls['participants']['controls'][i].valid  && !showSearchInput)">Clear attendee details</span>
                    </div>
                    <div *ngIf="searchAttendeeResult.length && showSearchInput" class="search-result">
                      <div class="searched-attendee" *ngFor="let user of searchAttendeeResult; let a = index"
                        (click)="fillAttendee(a, i, user)">
                        <div class="round-user-avatar">
                          <img class="blur" src="/assets/images/userImage1.jpg">
                        </div>
                        <div class="searched-user">{{user.first_name}}</div>
                        <span *ngIf="attendee_index == a" class="sign-complete-nui">
                          <svg class="card-cb-on-nui" width="12" height="8" viewBox="0 0 12 8" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M11.8243 0.159541C11.59 -0.0531803 11.2101 -0.0531803 10.9757 0.159541L3.78737 6.68516L1.02428 4.17684C0.789972 3.96412 0.410097 3.96414 0.175746 4.17684C-0.058582 4.38954 -0.058582 4.73439 0.175746 4.94711L3.3631 7.84053C3.59734 8.05323 3.97749 8.05308 4.21163 7.84053L11.8243 0.929831C12.0586 0.717131 12.0586 0.372262 11.8243 0.159541Z"
                              fill="#82FFCA" />
                          </svg>
                        </span>
                      </div>
                    </div>
                    <!-- <div class="attendee-buttons row">
                        <button i18n="purchase modal | Fill with my data" class="btn btn-primary" (click)="fillForMe(i)" *ngIf="user_info && participantForm.controls['participants']['controls'][i].invalid">
                          מלא עם הפרטים שלי
                        </button>
                        <button i18n="Clear attendee details" class="btn btn-danger" (click)="clearAttendee(i)">
                          מחק פרטי משתתף
                        </button>
                      </div> -->
                    <!-- Default inputs -->
                    <div *ngFor="let input of form_inputs?.default_inputs">
                      <app-form-inputs *ngIf="input.required != '0'" ngDefaultControl (age)="ageToDate($event)"
                        (selectInput)="selectHandler($event)" (radio)="radioHandler($event)"
                        (checkbox)="checkboxHandler($event)" (myBirthdayChanged)="myBirthdayChanged($event)" [eventPaymentMode]="eventPaymentMode"
                        [form]="participantForm.controls['participants']['controls'][i]" [input]="input" [counter]="i"
                        [ageDisplay]="event_details?.age_display"
                        [birth_date]="event_details?.birth_date"
                        [gender]="event_details?.gender"
                        [id_number]="event_details?.id_number"
                        [customClass]="'mt10 mb10 col-md-12 col-xs-12'">
                      </app-form-inputs>
                      <!-- Errors handling -->
                      <app-error-handling *ngIf="input.required != '0' && input.input_name !== 'age'" ngDefaultControl
                        [formControl]="participantForm.controls['participants']['controls'][i].controls[input.input_name]"
                        [inputName]="input.input_name" [formSubmited]="formSubmited"
                        [customClass]="'error col-md-12 col-xs-12 item-error'">
                      </app-error-handling>
                    </div>

                    <!-- For instagram_url input -->
                    <div *ngIf="event_details.instagram_url === 1">
                      <div class="cards-nui" [formGroup]="participantForm.controls['participants']['controls'][i]">
                        <label i18n="input label | instagram_url"
                               for="instagram_url"></label>
                        <input class="guest-input-text-nui form-control" trim="blur"
                               id="instagram_url" type="text"
                               name="instagram_url" formControlName="instagram_url"
                               placeholder="Instagram" i18n-placeholder>
                      </div>
                      <app-error-handling [@slideIn] *ngIf="event_details.instagram_url === 1" ngDefaultControl
                                          [formControl]="participantForm.controls['participants']['controls'][i].controls['instagram_url']" [inputName]="'instagram_url'"
                                          [formSubmited]="formSubmited" [customClass]="'error item-error'">
                      </app-error-handling>
                    </div>


                    <!-- NEW Custom inputs -->
                    <ng-container *ngFor="let input of new_custom_inputs; let k = index;">
                      <app-custom-form-inputs *ngIf="!input.blocked" class="section-item-end" style="width: 100%;" ngDefaultControl
                                              (selectInput)="selectHandler($event)"
                                              (radio)="cf_radioHandler(k,i,$event)"
                                              (checkbox)="checkboxHandler($event)"
                                              [form]="item"
                                              [input]="input"
                                              [counter]="i"
                                              [customClass]="'mt10 mb10 col-md-12 col-xs-12'">
                      </app-custom-form-inputs>

                      <app-error-handling *ngIf="!input.blocked" class="section-item-end" ngDefaultControl
                                          [formControl]="item.controls[input.id]"
                                          [inputName]="input.title" [formSubmited]="formSubmited"
                                          [customClass]="'error col-md-12 col-xs-12 item-error'">
                      </app-error-handling>
                    </ng-container>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-md-12 col-xs-12" *ngIf="coupons && !eventCoupons && !item_is_reg">
      <!-- CODE FOR SPECIFIC FEATURE -> NEED TO BE DELETED AFTER THE NEED IS OVER -->
      <div *ngIf="event_details?.event_id == 53684">
        <input [(ngModel)]="couponCheckBoxPeper" (change)="coupon($event.target.checked, 'peper')" type="checkbox"
          id="coupon_peper" name="have_coupon_peper">
        <label class="inline" for="coupon_peper">&nbsp; PEPPER client ?</label>
        <br>
        <input [(ngModel)]="couponCheckBox" (change)="coupon($event.target.checked, 'regular')" type="checkbox"
          id="coupon" name="have_coupon">
        <label class="inline" for="coupon">&nbsp;Got a coupon ?</label>

        <div *ngIf="couponModal" [@slideIn] class="form-inline row">
          <label i18n="@@Coupon" for="coupon_code" class="sr-only">Coupon</label>
          <div class="col-md-8 col-xs-12">
            <input [hidden]="!couponCheckBox" type="text" name="coupon_code"
              class="full-width" #couponCoderegular id="coupon_code" placeholder="Coupon">
            <input [hidden]="!couponCheckBoxPeper" type="text"
              name="coupon_code" class="full-width" #couponCodePeper id="coupon_code"
              placeholder="Enter six first digits of your credit card">
          </div>
          <div class="col-md-4 col-xs-12">
            <input type="button"
              (click)="getCorrectCouponDiscount(couponCoderegular.value, couponCodePeper.value)"
              class="btn btn-primary full-width" value="Activate coupon">
          </div>
        </div>
        <div *ngIf="couponName && couponName != ''" [@slideIn]
          class="item-success">
          Coupon {{couponName}} accepted successfully!
        </div>
      </div>
      <!-- END SPECIFIC FEATURE -->
      <div class="chb-wrapper" *ngIf="event_details?.event_id != 53684">
        <div class="checkbox-section">
          <div class="card-checkbox-on-nui">
            <svg *ngIf="couponModal" class="card-cb-on-nui" width="12" height="8" viewBox="0 0 12 8" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.8243 0.159541C11.59 -0.0531803 11.2101 -0.0531803 10.9757 0.159541L3.78737 6.68516L1.02428 4.17684C0.789972 3.96412 0.410097 3.96414 0.175746 4.17684C-0.058582 4.38954 -0.058582 4.73439 0.175746 4.94711L3.3631 7.84053C3.59734 8.05323 3.97749 8.05308 4.21163 7.84053L11.8243 0.929831C12.0586 0.717131 12.0586 0.372262 11.8243 0.159541Z"
                fill="#82FFCA" />
            </svg>
          </div>
          <input class="promotion-checkbox" [(ngModel)]="couponCheckBox" (change)="coupon($event.target.checked)"
            type="checkbox" id="coupon" name="have_coupon">
          <label i18n="@@PurchaseModalGotacoupon" class="checkbox-text inline" for="coupon">&nbsp; Got a coupon?</label>
        </div>
        <div *ngIf="couponModal" [@slideIn] class="order-buttons-nui promo-button">
          <!-- <label i18n="coupon section | label" for="coupon_code" class="promo-code-sign sr-only">קופון</label> -->
          <div class="promo-code-sign">
            <svg class="b-start" width="25" height="34" viewBox="0 0 25 34" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M24.071 29.0435L21.4124 24.4386C21.2379 24.1364 20.8513 24.0327 20.5491 24.2073C20.2468 24.3819 20.1432 24.7684 20.3178 25.0706L22.2163 28.3587L19.54 27.6488C19.2035 27.5597 18.8585 27.759 18.7678 28.0949L18.0506 30.75L13.9347 23.6211C14.6925 23.7845 15.5046 23.5013 15.9874 22.8661L16.7254 21.8948C16.863 21.7137 17.0723 21.6034 17.2994 21.5921L18.5106 21.5319C19.4697 21.4843 20.2523 20.7899 20.4137 19.8432L20.6217 18.6226C20.6597 18.4001 20.7928 18.2061 20.9871 18.0908L22.0444 17.4631C22.8649 16.9759 23.234 16.0013 22.9418 15.0928L22.5602 13.9059C22.4913 13.6918 22.5194 13.4592 22.6372 13.2676L23.2895 12.2075C23.7888 11.3962 23.6635 10.3626 22.9849 9.694L22.1027 8.82497C21.9423 8.66692 21.8594 8.44733 21.8754 8.22268L21.9637 6.98137C22.0317 6.02671 21.4392 5.16697 20.5228 4.89075L19.3547 4.53857C19.1376 4.47311 18.9614 4.31626 18.8712 4.10817L18.3823 2.98023C18.0051 2.11025 17.056 1.6109 16.1257 1.7939L14.9404 2.02652C14.7167 2.07037 14.4867 2.0135 14.3094 1.8703L13.3657 1.10864C12.6258 0.511335 11.5517 0.511272 10.8117 1.1087L9.8683 1.87037C9.69098 2.01356 9.46096 2.07044 9.23726 2.02664L8.05188 1.79403C7.12148 1.61128 6.17251 2.11025 5.79537 2.9801L5.30613 4.10848C5.21596 4.31645 5.03977 4.47323 4.8227 4.53876L3.65477 4.89094C2.7384 5.16716 2.1459 6.02696 2.2139 6.98156L2.30224 8.22287C2.31823 8.44758 2.23539 8.66711 2.07488 8.82516L1.19276 9.69413C0.514066 10.3626 0.388754 11.3963 0.88798 12.2076L1.54026 13.2678C1.65812 13.4592 1.68624 13.6919 1.61736 13.906L1.23567 15.0929C0.94359 16.0013 1.31258 16.9761 2.13314 17.4632L3.19042 18.0909C3.38468 18.2063 3.51783 18.4001 3.55587 18.6228L3.7639 19.8434C3.86166 20.4169 4.18774 20.8975 4.64254 21.1981L0.112979 29.0435C-0.0146713 29.2646 0.00327519 29.5408 0.158415 29.7436C0.313554 29.9464 0.575616 30.0357 0.822323 29.9704L4.36007 29.0318L5.30993 32.5483C5.37653 32.7948 5.58494 32.9771 5.83816 33.0102C5.86565 33.0138 5.89301 33.0155 5.92018 33.0155C6.14376 33.0155 6.3535 32.8967 6.46731 32.6996L10.6041 25.5343C10.7787 25.2321 10.6751 24.8456 10.3728 24.671C10.0706 24.4966 9.68403 24.6001 9.50956 24.9023L6.13346 30.75L5.41622 28.0949C5.32547 27.7589 4.98044 27.5595 4.64406 27.6487L1.96776 28.3587L5.90255 21.5435L6.87794 21.592C7.10499 21.6033 7.31422 21.7136 7.45186 21.8946L8.19021 22.866C8.58295 23.3827 9.19353 23.6665 9.81554 23.6665C10.1043 23.6665 10.3957 23.6053 10.6687 23.4778L11.7634 22.9666C11.8567 22.923 11.9563 22.9002 12.0565 22.8959L17.7166 32.6994C17.8304 32.8966 18.0401 33.0154 18.2637 33.0154C18.2909 33.0154 18.3183 33.0137 18.3457 33.0101C18.599 32.977 18.8074 32.7948 18.874 32.5481L19.8238 29.0317L23.3616 29.9702C23.6085 30.0358 23.8703 29.9463 24.0255 29.7435C24.1807 29.5408 24.1987 29.2647 24.071 29.0435ZM11.2287 21.8215L10.134 22.3328C9.80821 22.4848 9.41401 22.3875 9.19656 22.1014L8.45815 21.1299C8.09422 20.6512 7.54115 20.3596 6.94069 20.3298L5.72972 20.2695C5.36699 20.2515 5.07105 19.9889 5.01001 19.6308L4.80198 18.4103C4.70163 17.8215 4.34945 17.3089 3.83582 17.0039L2.77853 16.3762C2.46825 16.192 2.3286 15.8234 2.43906 15.4797L2.82074 14.2929C3.00274 13.7268 2.92843 13.1117 2.61682 12.6053L1.96454 11.5452C1.77572 11.2383 1.82311 10.8474 2.0798 10.5946L2.96192 9.72554C3.38626 9.30758 3.60535 8.72715 3.56301 8.13307L3.47467 6.8917C3.44895 6.53061 3.67303 6.20555 4.01965 6.10103L5.18758 5.74885C5.76157 5.57583 6.22749 5.16115 6.46586 4.61125L6.9551 3.48287C7.07801 3.19945 7.36149 3.02017 7.66267 3.02017C7.71101 3.02017 7.75986 3.02478 7.80852 3.03432L8.99384 3.26694C9.5852 3.3829 10.1933 3.23256 10.6624 2.85384L11.6058 2.09211C11.8856 1.86613 12.2919 1.8662 12.5717 2.09205L13.5152 2.85391C13.9842 3.2325 14.5924 3.38302 15.1836 3.26694L16.3689 3.03432C16.7206 2.96563 17.0797 3.15401 17.2223 3.48312L17.7112 4.61106C17.9496 5.16115 18.4156 5.57583 18.9896 5.74891L20.1577 6.10109C20.5044 6.20555 20.7284 6.53074 20.7027 6.89183L20.6144 8.13313C20.5721 8.72721 20.7911 9.3077 21.2155 9.7256L22.0976 10.5946C22.3543 10.8475 22.4017 11.2384 22.2129 11.5452L21.5606 12.6053C21.249 13.1117 21.1746 13.7269 21.3567 14.2929L21.7384 15.4798C21.8489 15.8235 21.7093 16.1921 21.3989 16.3763L20.3416 17.004C19.828 17.309 19.4759 17.8216 19.3755 18.4103L19.1675 19.6309C19.1065 19.9889 18.8105 20.2516 18.4478 20.2696L17.2366 20.3297C16.636 20.3595 16.0828 20.6512 15.719 21.13L14.981 22.1013C14.7634 22.3874 14.3691 22.4847 14.0435 22.3327L12.9489 21.8215C12.4022 21.5663 11.7753 21.5663 11.2287 21.8215Z"
                fill="#C4C4C4" />
            </svg>
            <svg class="m-star" width="16" height="16" viewBox="0 0 16 16" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.0888 0.373047C3.79311 0.373047 0.29834 3.86782 0.29834 8.16357C0.29834 12.4593 3.79311 15.9541 8.0888 15.9541C12.3845 15.9541 15.8793 12.4593 15.8793 8.16357C15.8793 3.86782 12.3845 0.373047 8.0888 0.373047ZM8.0888 14.6901C4.49013 14.6901 1.56233 11.7623 1.56233 8.16357C1.56233 4.56484 4.49007 1.63704 8.0888 1.63704C11.6875 1.63704 14.6153 4.56478 14.6153 8.16357C14.6153 11.7623 11.6875 14.6901 8.0888 14.6901Z"
                fill="#C4C4C4" />
            </svg>
            <svg class="s-star" width="11" height="10" viewBox="0 0 11 10" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.32495 0.670788L6.57751 3.6354L9.78425 3.91088C10.0067 3.93009 10.0971 4.20759 9.92831 4.35368L7.49596 6.461L8.22485 9.59595C8.2754 9.81381 8.03935 9.98517 7.84828 9.86941L5.09243 8.20741L2.33658 9.86941C2.14501 9.98466 1.90945 9.81331 1.96 9.59595L2.6889 6.461L0.256047 4.35317C0.087218 4.20709 0.177192 3.92958 0.400107 3.91037L3.60684 3.63489L4.8594 0.670788C4.94635 0.464555 5.23801 0.464555 5.32495 0.670788Z"
                fill="#C4C4C4" />
            </svg>
          </div>
          <!-- <div class="col-md-8 col-xs-12"> -->
          <input class="promo-code-text" i18n-placeholder="@@Coupon" type="text" name="coupon_code"
            #couponCode id="coupon_code" placeholder="Coupon">
          <!-- </div> -->
          <div class="coupon">

            <svg *ngIf="couponName" class="card-btn-on-nui" width="12" height="8" viewBox="0 0 12 8" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.8243 0.159541C11.59 -0.0531803 11.2101 -0.0531803 10.9757 0.159541L3.78737 6.68516L1.02428 4.17684C0.789972 3.96412 0.410097 3.96414 0.175746 4.17684C-0.058582 4.38954 -0.058582 4.73439 0.175746 4.94711L3.3631 7.84053C3.59734 8.05323 3.97749 8.05308 4.21163 7.84053L11.8243 0.929831C12.0586 0.717131 12.0586 0.372262 11.8243 0.159541Z"
                fill="#82FFCA" />
            </svg>
            <div class="card-checkbox-on-nui"></div>
            <input class="promotion-checkbox align-checkbox" i18n-value="@@ActivateCoupon"
              type="button" (click)="checkCouponDiscount(couponCode.value)"
              value="Activate coupon">
          </div>
        </div>
        <div i18n="@@PurchaseModalCouponAcceptedSuccessfully" *ngIf="couponName && couponName != ''" [@slideIn]
          class="item-success">
          Coupon {{couponName}} accepted successfully!
        </div>
      </div>

    </div>
    <div *ngIf="( (eventCoupons || eventDiscounts ) && (eventCoupons?.length || eventDiscounts?.length )) && !item_is_reg && !hasDonateTicket"
      class="col-md-12 col-xs-12 form-item ">
      <div class="control-group">
        <label i18n="@@PurchaseModalChoosecouponfromlist" for="eventCoupons" class="control-label">Choose coupon from list</label>
        <select [(ngModel)]="selectOptionCouponValue" #selectedCoupon (change)="checkCouponDiscount(selectedCoupon.value)"
          id="eventCoupons" class="form-control custom-input custom-arrow custom-select" name="coupons">
          <option i18n="@@ChooseCoupon" [value]="undefined">Choose coupon</option>
          <option *ngFor="let coupon of eventCoupons;" [value]="coupon.code">
            {{coupon.name}} - ({{coupon.remaining}} <span i18n="@@OutOf">out of</span> {{coupon.quantity}})</option>
          <option disabled *ngIf="eventDiscounts && eventDiscounts.length">Choose discount</option>
          <option *ngFor="let discount of eventDiscounts;" [value]="discount.code">
            {{discount.name}} - ({{discount.remaining}} <span i18n="@@OutOf">out of</span> {{discount.quantity}})</option>
        </select>
        <div i18n="@@PurchaseModalCouponAcceptedSuccessfully" *ngIf="couponName && couponName != ''" [@slideIn] class="item-success">
          Coupon {{couponName}} accepted successfully!
        </div>
      </div>
    </div>
    <div class="col-md-12 col-xs-12">
      <div class="order-amount-nui">

        <div class="checkbox-section">
          <div class="card-checkbox-on-nui ">
            <svg *ngIf="terms" class="card-cb-on-nui" width="12" height="8" viewBox="0 0 12 8" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.8243 0.159541C11.59 -0.0531803 11.2101 -0.0531803 10.9757 0.159541L3.78737 6.68516L1.02428 4.17684C0.789972 3.96412 0.410097 3.96414 0.175746 4.17684C-0.058582 4.38954 -0.058582 4.73439 0.175746 4.94711L3.3631 7.84053C3.59734 8.05323 3.97749 8.05308 4.21163 7.84053L11.8243 0.929831C12.0586 0.717131 12.0586 0.372262 11.8243 0.159541Z"
                fill="#82FFCA" />
            </svg>
          </div>
          <input class="promotion-checkbox" type="checkbox" (change)="checkedTerms($event.target.checked)" id="terms"
            name="terms">
          <label for="terms" class="checkbox-text white_span inline">&nbsp;<span i18n="@@PurchaseModalIherebyaccepted">I hereby accepted the</span>
            <span (click)="toggleTerms = !toggleTerms" class="pop_terms white_span" i18n="@@PurchaseModalGETINTermsofuse">GETIN&apos;s Terms of Use</span></label>
        </div>

        <div class="checkbox-section" *ngIf="showProducerSubscription">
          <div class="card-checkbox-on-nui">
            <svg *ngIf="checkBoxProducerSubscription" class="card-cb-on-nui" width="12" height="8" viewBox="0 0 12 8" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.8243 0.159541C11.59 -0.0531803 11.2101 -0.0531803 10.9757 0.159541L3.78737 6.68516L1.02428 4.17684C0.789972 3.96412 0.410097 3.96414 0.175746 4.17684C-0.058582 4.38954 -0.058582 4.73439 0.175746 4.94711L3.3631 7.84053C3.59734 8.05323 3.97749 8.05308 4.21163 7.84053L11.8243 0.929831C12.0586 0.717131 12.0586 0.372262 11.8243 0.159541Z"
                fill="#82FFCA" />
            </svg>
          </div>
          <input class="promotion-checkbox" type="checkbox" [checked]="checkBoxProducerSubscription" id="producer_subscription" name="producer_subscription" (change)="checkedProducerSubscription($event.target.checked)">
          <label i18n="ProducerSubscription disclaimer" for="producer_subscription" class="checkbox-text white_span inline">&nbsp;I accept receiving updates from this producer</label>
        </div>

        <div [hidden]="hideCorona"  class="checkbox-section">
            <div class="card-checkbox-on-nui ">
              <svg *ngIf="corona" class="card-cb-on-nui" width="12" height="8" viewBox="0 0 12 8" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.8243 0.159541C11.59 -0.0531803 11.2101 -0.0531803 10.9757 0.159541L3.78737 6.68516L1.02428 4.17684C0.789972 3.96412 0.410097 3.96414 0.175746 4.17684C-0.058582 4.38954 -0.058582 4.73439 0.175746 4.94711L3.3631 7.84053C3.59734 8.05323 3.97749 8.05308 4.21163 7.84053L11.8243 0.929831C12.0586 0.717131 12.0586 0.372262 11.8243 0.159541Z"
                  fill="#82FFCA" />
              </svg>
            </div>
          <input class="promotion-checkbox" type="checkbox" (change)="checkedCorona($event.target.checked)" id="corona" name="corona">
          <label for="corona" class="checkbox-text white_span inline">
            <a *ngIf="dir !== 'rtl'" href="https://static.get-in.com/files/corona.pdf" target="_blank" class="covid-text pop_terms white_span">&nbsp;Health declaration approval</a>
            <span *ngIf="dir === 'ltr'" class="white_span">&nbsp;
              By clicking register below, you are acknowledging that an inherent risk of COVID-19 exists in any public place
              where there are people present. By attending Profundo, you and any guests voluntarily assume all risks related to
              exposure of COVID -19 and agree not to hold Profundo, The Ravel Hotel or Good PAL corp or any of their affiliates or
              employees liable for any illness or injury.
            </span>
          </label>
        </div>
      </div>
      <div class="order-amount-nui" *ngIf="total && participantForm.valid">
        <div class="order-taxes">
          <span i18n="@@PurchaseModalTotalTickets">Total tickets: </span>
          <span>{{total.total_items}}</span>
        </div>
        <div class="order-total">
          <span i18n="@@PurchaseModalTotalPrice">total price:</span>
          <span>{{total_price_w_commission | currency:
            currency:currency === 'MXN' || currency === 'CAD' ? 'symbol': 'symbol-narrow':'1.0-2':getLocale(currency)}}</span>

        </div>
      </div>
    </div>
    <div class="all-buttons col-md-12 col-xs-12">
      <div class="btns" *ngFor="let gateway of paymentGateways">
        <div class="crypto-btn" (click)="toPayment(false, gateway)" *ngIf="gateway.payment_type === 'coinbase' && gateway.payment_type !== 'walletconnect' && gateway.payment_type !== 'solana'">
          <img class="crypto-img" src="/assets/images/crypto/bitcoin_icon.png" alt="Coinbase">
          <div i18n="label | Pay with coinbase" class="pay-with-text">Pay with Crypto</div>
        </div>
        <div class="crypto-btn" (click)="toPayment(false, gateway)" *ngIf="gateway.payment_type === 'walletconnect' && gateway.payment_type !== 'coinbase' && gateway.payment_type !== 'solana'">
          <img class="crypto-img" src="/assets/images/cripto_currency/walletconnect1.svg" alt="WalletConnect">
          <div i18n="label | Pay with Walletconnect" class="pay-with-text">Pay with WalletConnect</div>
        </div>
        <div class="crypto-btn" (click)="toPayment(false, gateway)" *ngIf="gateway.payment_type === 'solana' && gateway.payment_type !== 'coinbase' && gateway.payment_type !== 'walletconnect'">
          <img class="crypto-img" src="/assets/images/cripto_currency/solana_icon.svg" alt="solana">
          <div i18n="label | Pay with Solana" class="pay-with-text">Pay with Solana</div>
        </div>
        <button class="to_payment" (click)="showSeatsIo ? seatsToPayment(false, gateway):toPayment(false, gateway)" *ngIf="gateway.payment_type !== 'coinbase' && gateway.payment_type !== 'walletconnect' && gateway.payment_type !== 'solana'">
          <span i18n="@@PurchaseModalCompleteOrder" *ngIf="!canUseCash && !freeItem && !item_is_reg"
            class="continue_text">Complete order</span>
          <span i18n="@@PurchaseModalPayWithCreditCard" *ngIf="canUseCash && !freeItem && !item_is_reg"
            class="continue_text">Pay with credit card</span>
          <span i18n="@@FreeAdmission" *ngIf="item_is_reg" class="continue_text">Registration</span>
          <span i18n="payment method button | free" *ngIf="!item_is_reg && freeItem" class="continue_text">Free admission</span>
        </button>
      </div>
      <div *ngIf="canUseCash && !freeItem && !item_is_reg && !showSeatsIo">
        <button class="crypto-btn by-cash" (click)="showSeatsIo ? seatsToPayment(true, null):toPayment(true, null)">
          <span i18n="@@PayWithCash" class="continue_text">Pay with cash</span>
        </button>
      </div>
    </div>
  </div>
  <div [hidden]="step != 'payment_step'" class="row pay-row payment_timer">
    <div *ngIf="!full_purchase && !eventPaymentMode" class="close_modal">
      <div class="col-md-12 col-xs-12">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <!-- <div class="col-md-12 col-xs-12 text-center">
      <span i18n="credit payment section | timer">החשבון נשמר למשך 30 דקות בלבד!
        <countdown-timer (zeroTrigger)="closeModal()" [end]="purchaseTimer"></countdown-timer>
      </span>
    </div> -->
  </div>

  <div class="credit_form no_padding" [hidden]="step != 'payment_step'">
    <div class="row mt15" [style]="isCloseWallet ? 'margin-bottom: 15px; line-height: 20px;' : 'line-height: 20px;'" (click)="returnTo('items_section', 'init', true)">
      <div class="col-md-2 col-xs-2">
        <i class="fa {{faAngleRightRtlLeftLtr}} disabled icon-nav-size"></i>
      </div>
      <div class="col-md-10 col-xs-10">
        <p id="item_category" class="disabled"></p>
      </div>
    </div>
    <app-countdown-checkout-timer (stopTimer)="getStoppedCheckoutTimer($event)"></app-countdown-checkout-timer>
    <!-- <div class="errors"></div> -->
    <div *ngIf="!isOpenWallets && (!hasDonateTicket || (hasDonateTicket && donation_fee_mode))" class="order_sum">
      <div class="row" *ngIf="commission_ils !== '0'">
        <div class="col-md-6 col-xs-6">
          <p i18n="@@Handlingfee_" class="mb0">Handling fee:</p>
        </div>
        <div class="col-md-6 col-xs-6">
          <p class="mutate-float-left mb0"><span class="font_white"
              id="commission">{{commission_ils | currency:
            currency:currency === 'MXN' || currency === 'CAD' ? 'symbol': 'symbol-narrow':'1.0-2':getLocale(currency)}}</span></p>
        </div>
      </div>
      <div *ngIf="total_tax_commission > 0" class="order-taxes">
        <span i18n="credit payment section | tax_commission">Tax:</span>
        <span>{{total_tax_commission | currency:
          currency:currency === 'MXN' || currency === 'CAD' ? 'symbol': 'symbol-narrow':'1.0-2':getLocale(currency)}}</span>
      </div>
      <div *ngIf="total_purchaser_commission !== '0.00'" class="order-taxes">
        <span i18n="credit payment section | total_purchaser_commission">Purchase fee:</span>
        <span>{{total_purchaser_commission | currency:
          currency:currency === 'MXN' || currency === 'CAD' ? 'symbol': 'symbol-narrow':'1.0-2':getLocale(currency)}}</span>
      </div>
      <div *ngIf="(total_service_commission !== '0.00' || total_platform_fee)" class="order-taxes">
        <span i18n="credit payment section | total_service_commission">Service fee:</span>
        <span>{{(+total_service_commission + total_platform_fee) | currency:
          currency:currency === 'MXN' || currency === 'CAD' ? 'symbol': 'symbol-narrow':'1.0-2':getLocale(currency)}}</span>
      </div>
      <div class="row" *ngIf="total_discount != 0">
        <div class="col-md-6 col-xs-6 discount_html">
          <p i18n="@@PurchaseModalUsediscount" class="mb0">Use discount:</p>
        </div>
        <div class="col-md-6 col-xs-6 discount_html">
          <p class="mutate-float-left mb0"><span id="total_discount"
              class="font_white">{{total_discount.toFixed(2) | currency:
            currency:currency === 'MXN' || currency === 'CAD' ? 'symbol': 'symbol-narrow':'1.0-2':getLocale(currency)}}</span></p>
        </div>
      </div>
    </div>
    <div *ngIf="!isOpenWallets" class="total-sum">
      <div class="row pay_row total">
        <div class="col-md-6 col-xs-6">
          <span i18n="@@PurchaseModalTotaltopay" class="font_white">Total to pay: </span>
        </div>
        <div class="col-md-6 col-xs-6">
          <span class="font_white mutate-float-left"><span class="font_white"
              id="remaining_payment">{{remaining_payment | currency:
            currency:currency === 'MXN' || currency === 'CAD' ? 'symbol': 'symbol-narrow':'1.0-2':getLocale(currency)}}</span></span>
        </div>
      </div>
    </div>
    <!--------------------------------------------------------  SolanaConnect --------------------------------------------->
    <div style="width: 100%;" [hidden]="!(gateway_type === 'solana')">
      <!-- <span class="wallet-img"><img width="80" class="img-responsive wallet-icon" src="./assets/images/cripto_currency/walletconnect1.svg"></span> -->
      <div class="cripto-wrapper col-md-12 col-xs-12 pl0 pr0" *ngIf="!isSelectedTicketOutOfStock">
          <div class="cripto-section col-md-12 col-xs-12 pl0 pr0">
              <div id="solana_crypto_holder" class="solana-block">
                  <app-solana-connect *ngIf="!isCloseSolanaWallet"
                  (getTrnBtnStatus)="setSolBtnStatus($event)"
                  (getTransactionWallet)="setSolanaTransactionWallet($event)"
                  [openWallets]="isOpenSolanaWallets"
                  [walletData]="solanaConnectData"
                  [solanaTransactionBtnStatus]="solanaTransactionBtnStatus"
                  ></app-solana-connect>
              </div>
          </div>
      </div>
    </div>
    <!--------------------------------------------------------  WalletConnect --------------------------------------------->
    <div style="width: 100%;" [hidden]="!(gateway_type === 'walletconnect')">
      <!-- <span class="wallet-img"><img width="80" class="img-responsive wallet-icon" src="./assets/images/cripto_currency/walletconnect1.svg"></span> -->
      <div class="cripto-wrapper col-md-12 col-xs-12 pl0 pr0" *ngIf="!isSelectedTicketOutOfStock">
          <div class="cripto-section col-md-12 col-xs-12 pl0 pr0">
              <div id="crypto_holder" class="center-block">
                  <app-wallet-connect *ngIf="!isCloseWallet"
                  [openWallets]="isOpenWallets"
                  [walletData]="walletConnectData"
                  (getTransactionWallet)="setTransactionWallet($event)"
                  [transactionBtnStatus]="transactionBtnStatus"
                  (getTrnBtnStatus)="setTrnBtnStatus($event)">
                </app-wallet-connect>
              </div>
          </div>
      </div>
    </div>
     <!--------------------------------------------------------  Coinbase --------------------------------------------->
     <div style="width: 100%;" [hidden]="!(gateway_type === 'coinbase')">
      <div class="cripto-wrapper col-md-12 col-xs-12 pl0 pr0">
          <div class="cripto-section col-md-12 col-xs-12 pl0 pr0">
              <div id="crypto_holder" class="center-block">
                  <div *ngIf="coinBaseData?.data && cryptoPaymentStatus === 0">
                      <div class="wallet-title">
                          <!-- <div class="wallet-user">User:<span class="wallet-info">{{coinBaseData?.data.name}}</span></div>
                          <div class="wallet-desc">Description:<span class="wallet-info">{{coinBaseData?.data.description}}</span></div> -->
                          <!-- <div class="wallet-amount">Payment amount: <span class="wallet-info">{{coinBaseData?.data.pricing.local.amount}} {{coinBaseData?.data.pricing.local.currency}}</span></div> -->
                      </div>
                      <div class="wallet-title">
                          <div i18n="button payment | Pay with coinbase" class="pay-with-btn" (click)="payWithCoinbase()">Pay with coinbase</div>
                      </div>
                      <div class="wallet-coins"><span i18n="section title | Crypto wallets" class="wallet-coin">Crypto wallets:</span>
                          <div class="wallet-crypto" *ngFor="let item of coinBaseData?.data.addresses | keyvalue">
                              <div class="cripto-currency">
                                  <img class="cripto-cur-img" [src]="'./../../assets/images/cripto_currency/' + item.key + '_icon.png'" alt="cripto currency icon">
                                  <div class="wallet-name" (click)="toggleCoinBase(item.key)">{{item.key}}</div>
                              </div>
                              <div class="wallet-wrapper"  [@slideIn] *ngIf="toggleCripto === item.key">
                                  <div class="exchange-rate-wrapper" *ngIf="coinBaseData?.data.pricing[item.key]">
                                      <div class="wallet-data">
                                          <span i18n="section title | Exchange rate"  class="exchange-rate-title">Exchange rate: </span>
                                          <span class="exchange-rate"> {{coinBaseData?.data.pricing[item.key].amount | number : '1.0-9'}} {{coinBaseData?.data.pricing[item.key].currency}}</span>
                                      </div>
                                      <span i18n="button | copy wallet key" class="wallet-copy" (click)="copyWalletData(coinBaseData?.data.pricing[item.key].amount)" >Copy</span>
                                  </div>
                                  <div class="wallet-key">
                                      <div class="wallet-data">
                                          <span class="wallet-key-start">{{item.value.substring(0,item.value.length/2)}}</span>
                                          <span class="wallet-key-middle">..........................................................................</span>
                                          <span class="wallet-key-end">{{item.value.substr(item.value.length/2)}}</span>
                                      </div>
                                      <span i18n="button | copy wallet key" class="wallet-copy" (click)="copyWalletData(item.value)" >Copy</span>
                                  </div>
                                  <div *ngIf="false" class="wallet-payment" (click)="checkCryptoPayment(coinBaseData?.data.code, coinBaseData?.data.id, item.key, item.value, coinBaseData?.data.pricing[item.key].amount, coinBaseData?.data.pricing[item.key].currency)">
                                      <!-- <div class="wallet-check-btn">Check payment <span class="wallet-check-coin"> {{item.key}}</span></div> -->
                                      <div i18n="button | Send request" class="wallet-check-btn">Send request</div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <!-- <div class="wallet-check">
                          <div class="wallet-check-btn" (click)="checkCriptoPayment()">Check payment</div>
                      </div> -->
                      <!-- <div> Exchange Rate:
                          <p *ngFor="let item of coinBaseData?.data.pricing | keyvalue">
                              <b>{{item.key}}</b>: {{item.value.amount}} {{item.value.currency}}
                          </p>
                      </div> -->
                  </div>
                  <div *ngIf="cryptoPaymentStatus === 1" class="crypto-status">
                      <!-- <div class="crypto-attention">IMG isset transaction</div> -->
                      <div class="crypto-title"><span class="title-text">Verifying payment</span></div>
                      <div class="crypto-attention attention-true">Transfer from your wallet <span class="crypto-check check-true">&#10004;</span></div>
                      <div class="crypto-message" style="margin: 0;"><span>You've successfully sent a payment.</span></div>
                      <div class="crypto-message"><span>We are waiting for it to be veryfied by the network. Your payment has recive 0 of 1 confirmation.</span></div>
                  </div>
                  <div *ngIf="cryptoPaymentStatus === 2" class="crypto-status">
                      <!-- <div class="crypto-attention">IMG success</div> -->
                      <div class="crypto-title"><span class="title-text">Successfully payment</span></div>
                      <div class="crypto-attention attention-true">Payment received successfully<span class="crypto-check check-true">&#10004;</span></div>
                  </div>
                  <div *ngIf="cryptoPaymentStatus === 3" class="crypto-status">
                      <!-- <div class="crypto-attention">IMG unresolved</div> -->
                      <div class="crypto-title"><span class="title-text">Underpayment</span></div>
                      <div class="crypto-attention attention-false">Payment is less than required.<span class="crypto-check check-false">&#10006;</span></div>
                      <div class="crypto-message"><span>The merchant received your payment but the amount received was less then that what was required.</span></div>
                      <div class="crypto-message"><span>Please contact the merchant at</span><span>merchant@get-in.com</span><span>with your order code to resolve your payment.</span></div>
                      <div *ngIf="cryptoPaymentOrderCode" class="crypto-order-text"><span>Your order code is:</span></div>
                      <div *ngIf="cryptoPaymentOrderCode" class="crypto-order-code"><span class="order-code">{{cryptoPaymentOrderCode}}</span></div>
                  </div>
              </div>
          </div>
      </div>
    </div>

    <div class="col-md-12 col-xs-12 pl0 pr0" [hidden]="(gateway_type === 'walletconnect') || (gateway_type === 'coinbase') || (gateway_type === 'solana')">
      <div class="col-md-12 col-xs-12 pl0 pr0">
        <div id="iframe_holder" class="center-block">
          <iframe [ngStyle]="{'display': iframeDisplay}" id="load_payment" (load)="onLoadIframe()"
            class="embed-responsive-item" name="load_payment" width="100%" height="750px" frameborder="0"
            scrolling="no">
            Use a browser that supports Iframes to see the content.</iframe>
          <form #tokenForm [action]="boa_url" method="post" target="load_payment">
            <input #tokenInput id="hptoken" type="hidden" name="token" [value]="token" />
          </form>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-xs-12 pl0 pr0" [hidden]="(gateway_type === 'walletconnect') || (gateway_type === 'coinbase') || (gateway_type === 'solana')">
      <div class="col-md-12 col-xs-12 pl0 pr0">
        <div id="holder" class="center-block">
          <form #checkout="ngForm" (ngSubmit)="stripeOnSubmit(checkout)" class="checkout">
            <div class="form-row">
              <div id="card-info" #cardInfo></div>
              <div class="card-errors" id="card-errors" role="alert" *ngIf="cardErrors">{{ cardErrors?.message }}</div>
            </div>
            <button i18n="@@PurchaseModalpaybutton" *ngIf="gateway_type == 'stripe_gateway'"
              [disabled]="!stripe_form?.complete || isClickedStripeButton" type="submit">Pay</button>
          </form>
        </div>
      </div>
    </div>

    <div *ngIf="externalApi" class="col-md-12 col-xs-12 external_api mt20 pl0 pr0">
      <div class="col-md-12 col-xs-12 pl0 pr0">
        <button class="mt10" (click)="extranalApi()">
          <span i18n="@@PurchaseModalpaybutton">Pay</span>
        </button>
      </div>
    </div>

    <div *ngIf="!externalApi">
      <div class="row tranzilla_form mt20 pl0 pr0" [hidden]="(gateway_type === 'walletconnect') || (gateway_type === 'coinbase') || (gateway_type === 'solana') || (gateway_type === 'hyper_switch')">
        <div class="col-md-12 col-xs-12">
          <iframe *ngIf="tranzillaUrl" id="tranzilla_form"
            [src]="tranzillaUrl" width="100%">Use a browser that supports I-frames to see the content.</iframe>
        </div>
      </div>
    </div>

    <!------------------------------------------------------------ Hyperswitch -------------------------------------------->
    <form id="hyper-payment-form" *ngIf="gateway_type == 'hyper_switch'" (ngSubmit)="hyper_switchSubmit($event)">
      <div id="unified-checkout" #unified_checkout>
        <!--hyperLoader injects the Unified Checkout-->
      </div>
      <button id="hyper-submit" [disabled]="hyperSubmitDisable" [ngClass]="hyperSubmitHidden?'hidden':''">
        <div class="spinner hidden" id="spinner"></div>
        <div id="button-text">Pay</div>
      </button>
      <div id="hyper-payment-message" #hyper_errors></div>
    </form>

  </div>
  <div class="payment-form">
    <div [hidden]="step != 'payment_step'">
      <div *ngIf="!isCloseWallet" class="payment-btn">
        <div class="to_payment" *ngIf="isOpenWallets"
            [style]="trnBtnStatus ? 'opacity: 1; cursor: pointer;' : 'opacity: 0.5; cursor: not-allowed;'"
            (click)="trnBtnStatus ? walletConnectPay(true) : null">
            <div i18n="payment method button | continue" class="pay-by-coin">Send Payment</div>
        </div>
      </div>
    </div>
  </div>
  <div class="payment-form">
    <div [hidden]="step != 'payment_step'">
      <div *ngIf="!isCloseSolanaWallet" class="payment-btn">
        <div class="to_payment" *ngIf="isOpenSolanaWallets"
            [style]="trnSolBtnStatus ? 'opacity: 1; cursor: pointer;' : 'opacity: 0.5; cursor: not-allowed;'"
            (click)="trnSolBtnStatus ? walletSolanaPay(true) : null">
            <div i18n="payment method button | continue" class="pay-by-coin">Send Payment</div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Terms Modal -->
<div *ngIf="toggleTerms" [@fade] id="terms-modal" class="modal show" role="dialog"
  aria-labelledby="exampleModalLongTitle">
  <div class="modal-dialog" role="document">
    <div class="modal-content m20">
      <div class="modal-header">
        <button (click)="toggleTerms = !toggleTerms" type="button" class="close">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-terms></app-terms>
      </div>
      <div class="modal-footer">
        <button i18n="@@Close" (click)="toggleTerms = !toggleTerms" type="button" style="color: #000;"
          class="btn btn-secondary">Close</button>
      </div>
    </div>
  </div>
</div>


<!-- templateSeats -->
<ng-template #templateSeats>
  <div class="seats-next-head">
    <!--          <p (click)="getSeatsCats()">GET CATS</p>-->
    <mat-accordion *ngIf="seatsSupportsBestAvailable">
      <mat-expansion-panel (opened)="seatsPanelOpenState = true"
                           (closed)="seatsPanelOpenState = false; toggleBestSeats = false;" class="seats-panel"
                           [togglePosition]="'before'"
                           [hideToggle]="!seatsPanelOpenState"
                           [ngStyle]="{'background': seatsPanelOpenState ? '#fff' : isMobile ? 'none' : '#fff'}">
        <mat-expansion-panel-header [expandedHeight]="'90px'" [collapsedHeight]="'64px'">
          <mat-panel-title>
            <div class="seats-head-title" [ngStyle]="{'background': seatsPanelOpenState ? 'none' : '#e6eaee'}">
              <p><img *ngIf="!seatsPanelOpenState" src="/assets/images/svg-icons/magicpen.svg" alt=""></p>
              <p class="seats-p-15" *ngIf="!seatsPanelOpenState" i18n="seats|txt3">Find the Best Seats view</p>
              <p class="seats-p-17" *ngIf="seatsPanelOpenState" i18n="seats|txt2">How Many Tickets You Need? We Will Find The Best Match 🥳</p>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="seats-qty-choose" (click)="toggleBestSeats = !toggleBestSeats" *ngIf="!toggleBestSeats">
          <p class="seats-p-14" i18n="seats|Quantity">Quantity</p>
          <p class="seats-p-14"><span i18n="seats|choose">choose</span> <img src="/assets/images/svg-icons/arrow-right-blk.svg" alt=""></p>
        </div>
        <div class="seats-best" *ngIf="toggleBestSeats">
          <div class="seats-best-item" (click)="bestSeats(key)" *ngFor="let key of [1,2,3,4,5,6,7,8,9,10]">
            {{key}}
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div class="seats-next" [ngStyle]="!seatsSupportsBestAvailable && {'border-radius': '20px'}">


    <ng-container>
      <!--VIEW TICKETS Accordion-->
      <mat-accordion>
        <mat-expansion-panel class="seats-panel-tickets" [togglePosition]="'before'" [expanded]="!isMobile">
          <mat-expansion-panel-header *ngIf="isMobile">
            <mat-panel-title>
              <div>
                <span class="seats-p-15" i18n="seats|view tickets">VIEW TICKETS</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="seats-selected-wrap" *ngIf="listSelectedObjects">
            <div *ngFor="let t of seatsTickets; last as isLast">
              <div class="seats-selected" [ngStyle]="{'border-bottom': isLast ? 'none' : '1px solid #E6EAEE'}">
                <p>
                  <img *ngIf="t.ticket.availability == 1" src="/assets/images/seats-chair.png" alt="">
                  <img [matTooltip]="tooltipTxt(t)" *ngIf="t.ticket.availability !== 1" src="/assets/images/svg-icons/menu-info-circle.svg" alt="" class="seats-invalid-ticket">
                </p>
                <div class="seats-txt"
                     [ngStyle]="{'opacity': t.ticket.availability !== 1 ? '0.5' : '1'}">
                  <div>
                    <span i18n="seats|Row" *ngIf="t.parent.type === 'row'">Row: </span>
                    <span i18n="seats|Table" *ngIf="t.parent.type === 'table'">Table: </span>
                    <span class="seat-badge">{{t.labels.parent}}</span><span i18n="seats|Seat"> Seat: </span><span class="seat-badge">{{t.labels.own}}</span>
                  </div>
                  <div style="line-height: 1;">
                            <span class="seats-price">{{t.price | currency:
                              currency:currency === 'MXN' || currency === 'CAD' ? 'symbol': 'symbol-narrow':'1.0-2':getLocale(currency)}}</span>
                  </div>
                </div>
                <p class="seats-remove" (click)="deselectObjects(t.seatId)"><img src="/assets/images/svg-icons/trash.svg" alt=""></p>
              </div>

            </div>
          </div>
          <p class="no-seats-txt" *ngIf="!seatsQuantity" i18n="seats|select floor">Click on the floor plan to select your seats</p>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>
    <!--MOBILE CHECKOUT BTN-->
    <div class="seats-btn-continue" *ngIf="chartSeatsRendered && isMobile">
      <div class="purchase-btn-total">
        <p class="purchase-btn-total-price">{{total_price_w_commission | currency:
          currency:currency === 'MXN' || currency === 'CAD' ? 'symbol': 'symbol-narrow':'1.0-2':getLocale(currency)}}</p>
        <p class="purchase-btn-total-tickets">{{seatsQuantity}}&nbsp;<span i18n="purchase-btn-total">{seatsQuantity,
          plural, =1 {ticket} other {tickets}}</span></p>
      </div>
      <div class="seats-button-text">
        <button [disabled]="!seatsQuantity || seatsTicketsHaveInvalidItem" i18n="payment button | Go To Checkout" class="seats-button-continue mb0" (click)="toParticipantData(); setSeatsObjects();">Go To Checkout</button>
      </div>
    </div>
    <!--DESKTOP CHECKOUT BTN-->
    <div class="seats-btn-continue-black" *ngIf="chartSeatsRendered && !isMobile">
      <button [disabled]="!seatsQuantity || seatsTicketsHaveInvalidItem" (click)="toParticipantData(); setSeatsObjects();" class="seats-button-continue mb0">
        <div class="seats-1-row">
          <span class="seats-checkout-txt" i18n="seats|Checkout">Checkout</span>
          <p class="purchase-btn-total-tickets">{{seatsQuantity}}&nbsp;<span i18n="purchase-btn-total">{seatsQuantity,
            plural, =1 {ticket} other {tickets}}</span></p>
        </div>
        <p class="purchase-btn-total-price">{{total_price_w_commission | currency:
          currency:currency === 'MXN' || currency === 'CAD' ? 'symbol': 'symbol-narrow':'1.0-2':getLocale(currency)}}</p>
      </button>
    </div>
  </div>
</ng-template>
